const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const ArduinoWriter = require('../kurikit_makerBoard/arduino-writer');
const TinyMLChartWindow = require('./chart-window');
const env = require('../env');

const BUILD_SERVER_URL = env === 'production'
    ? 'https://build.kurikit.ux-xu.com/exec/post'
    : 'https://staging.build.kurikit.ux-xu.com/exec/post';

const blockIconURI = 'data:image/svg+xml;base64,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'
const menuIconURI = 'data:image/svg+xml;base64,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'

if (typeof window !== 'undefined') {
    window.TinyMLShared = {
        model: null,
        labelMap: null,
        trainingAccuracy: 0,
        validationAccuracy: 0,
        isModelTrained: false
    };
}

class TinyMLExtension {
    constructor(runtime) {
        this.runtime = runtime;

        // makerBoard 拡張が「書込時に自動でセンサー切断」するための逆参照。
        // window.TinyMLShared に既にあるストア/モデル情報と同じ場所に格納する。
        if (typeof window !== 'undefined' && window.TinyMLShared) {
            window.TinyMLShared.instance = this;
        }

        // データ管理
        this.dataBuffer = [];
        this.datasets = new Map();
        
        // 状態管理
        this.isStreaming = false;
        this.isCollecting = false;
        this.sensorType = null;
        this.port = null;
        this.reader = null;
        
        // モデル関連（ローカル）
        this.model = null;
        this.labelMap = new Map();
        this.trainingAccuracy = 0;
        this.validationAccuracy = 0;
        
        // 推論結果のキャッシュ
        this.lastPrediction = null;
        this.lastConfidence = 0;
        this.lastPredictionTime = 0;
        this.inferenceWindowBuffer = [];
        
        this.currentData = { x: 0, y: 0, z: 0 };

        // デバッグモード
        this.debugMode = false;

        // グラフウィンドウ管理
        this.chartWindow = new TinyMLChartWindow();

        // 子供向けUX: ラベルに付けた名前 (例: "1" → "なでる")
        this.labelNames = new Map();

        // 直前の収集を取り消す(undo)用: {label, count} を保持
        this.lastCollectionRecord = null;

        // カウントダウン用 AudioContext（初回 collectData 時に lazy 生成）
        this._audioCtx = null;
    }

    /**
     * 内部ヘルパー: ラベル番号を「名前(番号)」形式の表示文字列に変換
     * 名前が未設定なら番号だけを返す
     */
    _labelDisplay(label) {
        const name = this.labelNames.get(String(label));
        return name ? `${name}(${label})` : String(label);
    }

    /**
     * 内部ヘルパー: 短いビープ音を鳴らす（カウントダウン用）
     * Web Audio API。失敗してもサイレントに継続。
     */
    _beep(freq = 600, durMs = 120) {
        try {
            if (typeof window === 'undefined') return;
            if (!this._audioCtx) {
                const AC = window.AudioContext || window.webkitAudioContext;
                if (!AC) return;
                this._audioCtx = new AC();
            }
            const ctx = this._audioCtx;
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.value = freq;
            gain.gain.value = 0.15;
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start();
            osc.stop(ctx.currentTime + durMs / 1000);
        } catch (e) { /* silent */ }
    }

    getInfo() {
        return {
            id: 'tinyml',
            name: 'メイカーボード TinyML',
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            color1: '#FF6B35',
            color2: '#E55A2B',
            blocks: [
                {
                    opcode: 'setupSensor',
                    blockType: BlockType.COMMAND,
                    text: '[SENSOR]をセットアップ',
                    arguments: {
                        SENSOR: {
                            type: ArgumentType.STRING,
                            menu: 'sensors',
                            defaultValue: 'accelerometer'
                        }
                    }
                },
                {
                    opcode: 'reconnectSensor',
                    blockType: BlockType.COMMAND,
                    text: 'センサーを再接続(書き込みなし)'
                },
                {
                    opcode: 'stopSensor',  // ← 新規追加
                    blockType: BlockType.COMMAND,
                    text: 'センサー接続を停止'
                },
                '---',
                {
                    opcode: 'openChart',
                    blockType: BlockType.COMMAND,
                    text: 'グラフウィンドウを開く'
                },
                {
                    opcode: 'closeChart',
                    blockType: BlockType.COMMAND,
                    text: 'グラフウィンドウを閉じる'
                },
                '---',
                {
                    opcode: 'setLabelName',
                    blockType: BlockType.COMMAND,
                    text: 'ラベル[LABEL]に名前[NAME]をつける',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,
                            menu: 'labels',
                            defaultValue: '1'
                        },
                        NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'なでる'
                        }
                    }
                },
                {
                    opcode: 'getLabelName',
                    blockType: BlockType.REPORTER,
                    text: 'ラベル[LABEL]の名前',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,
                            menu: 'labels',
                            defaultValue: '1'
                        }
                    }
                },
                '---',
                {
                    opcode: 'collectData',
                    blockType: BlockType.COMMAND,
                    text: 'ラベル[LABEL]を[DURATION]秒収集',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,  // ← STRING から NUMBER に変更
                            menu: 'labels',            // ← メニュー追加
                            defaultValue: '1'
                        },
                        DURATION: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 5
                        }
                    }
                },
                {
                    opcode: 'undoLastCollection',
                    blockType: BlockType.COMMAND,
                    text: 'さっきの収集を取り消す'
                },
                {
                    opcode: 'clearLabel',
                    blockType: BlockType.COMMAND,
                    text: 'ラベル[LABEL]のデータだけ削除',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,
                            menu: 'labels',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'getDataCount',
                    blockType: BlockType.REPORTER,
                    text: 'ラベル[LABEL]のデータ数',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,  // ← 変更
                            menu: 'labels',            // ← 追加
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'checkDataBalance',
                    blockType: BlockType.REPORTER,
                    text: 'データのバランス'
                },
                // '---',
                // {
                //     opcode: 'getCurrentSensorValue',
                //     blockType: BlockType.REPORTER,
                //     text: '現在の[AXIS]軸の値',
                //     arguments: {
                //         AXIS: {
                //             type: ArgumentType.STRING,
                //             menu: 'axes',
                //             defaultValue: 'x'
                //         }
                //     }
                // },
                '---',
                {
                    opcode: 'trainModel',
                    blockType: BlockType.COMMAND,
                    text: 'モデルを学習する'
                },
                {
                    opcode: 'getAccuracy',
                    blockType: BlockType.REPORTER,
                    text: '学習精度(%)'
                },
                {
                    opcode: 'isModelTrained',
                    blockType: BlockType.BOOLEAN,
                    text: 'モデルは学習済み？'
                },
                '---',
                {
                    opcode: 'classify',
                    blockType: BlockType.REPORTER,
                    text: '識別結果'
                },
                // {
                //     opcode: 'getConfidence',
                //     blockType: BlockType.REPORTER,
                //     text: '識別信頼度(%)'
                // },
                {
                    opcode: 'isLabel',
                    blockType: BlockType.BOOLEAN,
                    text: '識別結果がラベル[LABEL]？',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,  // ← 変更
                            menu: 'labels',            // ← 追加
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'showDatasetInfo',
                    blockType: BlockType.REPORTER,
                    text: 'データセット情報'
                },
                {
                    opcode: 'clearModel',
                    blockType: BlockType.COMMAND,
                    text: 'モデルのみ削除'
                },
                {
                    opcode: 'clearData',
                    blockType: BlockType.COMMAND,
                    text: '全データを削除'
                },
                '---',
                {
                    opcode: 'updateInference',
                    blockType: BlockType.COMMAND,
                    text: '推論を更新(メイカーボード書き込み用ブロック)'
                },
                {
                    opcode: 'classifyOnArduino',
                    blockType: BlockType.REPORTER,
                    text: '識別結果(メイカーボード書き込み用ブロック)'
                },
                {
                    opcode: 'isLabelOnArduino',
                    blockType: BlockType.BOOLEAN,
                    text: '識別結果がラベル[LABEL]？(メイカーボード書き込み用ブロック)',
                    arguments: {
                        LABEL: {
                            type: ArgumentType.NUMBER,  // ← 変更
                            menu: 'labels',            // ← 追加
                            defaultValue: '1'
                        }
                    }
                },
                '---',
                {
                    opcode: 'setDebugMode',
                    blockType: BlockType.COMMAND,
                    text: 'デバッグモードを[MODE]にする',
                    arguments: {
                        MODE: {
                            type: ArgumentType.STRING,
                            menu: 'debugModes',
                            defaultValue: 'on'
                        }
                    }
                },
            ],
            menus: {
                sensors: {
                    acceptReporters: true,
                    items: [
                        { text: '加速度センサー', value: 'accelerometer' },
                        { text: 'マイク', value: 'microphone' }
                    ]
                },
                axes: {
                    acceptReporters: true,
                    items: ['x', 'y', 'z']
                },
                labels: {  // ← 新しいメニュー追加
                    acceptReporters: true,
                    items: [
                        { text: '1', value: '1' },
                        { text: '2', value: '2' },
                        { text: '3', value: '3' },
                        { text: '4', value: '4' },
                        { text: '5', value: '5' }
                    ]
                },
                debugModes: {
                    acceptReporters: false,
                    items: [
                        { text: 'オン', value: 'on' },
                        { text: 'オフ', value: 'off' }
                    ]
                }
            }
        };
    }

    /**
     * センサーセットアップブロック
     */
    async setupSensor(args) {
        const sensorType = args.SENSOR;
        const runtime = this.runtime;
        const emitProgress = (stage, message) => {
            try {
                runtime.emit('MAKERBOARD_WRITE_PROGRESS',
                    message ? { stage, message } : { stage });
            } catch (e) { /* runtime未準備でも続行 */ }
        };

        // Web Serial API対応チェック
        if (!('serial' in navigator)) {
            emitProgress('error', 'このブラウザはWeb Serial APIに対応していません。Google Chromeを使用してください。');
            return;
        }

        // センサー種別を切り替える場合、既存データが別センサーで取られていたら警告する。
        // (混在データを学習すると意味の違う特徴量が混ざって精度がでないため)
        // 自動削除はしない。判断はユーザーに委ねる。
        if (this.sensorType && this.sensorType !== sensorType && this.datasets.size > 0) {
            const proceed = (typeof window !== 'undefined' && window.confirm)
                ? window.confirm(
                    `センサーを「${this.sensorType}」から「${sensorType}」に切り替えようとしています。\n` +
                    `現在、別のセンサーで集めた学習データが残っています。\n\n` +
                    `そのまま続けると学習データが混ざって精度が下がる可能性があります。\n` +
                    `先に「全データを削除」を実行することを推奨します。\n\n` +
                    `このまま続けますか？`)
                : true;
            if (!proceed) {
                emitProgress('error', 'セットアップを中止しました。');
                return;
            }
        }

        // 既にストリーミング中の場合、自動停止
        if (this.isStreaming) {
            console.log('[TinyML] 既存の接続を停止します...');
            try {
                await this.stopStreaming();
                await new Promise(resolve => setTimeout(resolve, 500));
            } catch (error) {
                console.error('[TinyML] 既存接続の停止に失敗:', error);
                emitProgress('error', '既存の接続を停止できませんでした。USBケーブルを抜き差ししてもう一度お試しください。');
                return;
            }
        }

        try {
            // データ収集用プログラム生成
            const program = this.generateDataCollectionProgram(sensorType);

            // ポート選択 (ブラウザ標準ダイアログ — UX上必須)
            this.port = await navigator.serial.requestPort();

            // === コンパイル (makerBoard 書込ボタンと同じ進捗UIを使う) ===
            emitProgress('compiling');
            const response = await fetch(BUILD_SERVER_URL, {
            // const response = await fetch('http://localhost:8080/exec/post', {  // ローカルテスト用
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    board: 'pro',
                    source: program
                }),
                signal: AbortSignal.timeout(20000)
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(`コンパイルエラー: ${data.text}`);
            }

            const hexData = await response.arrayBuffer();

            // === 書き込み ===
            emitProgress('writing');
            const ArduinoWriter = require('../kurikit_makerBoard/arduino-writer');
            const writer = new ArduinoWriter({
                board: 'pro-mini',
                port: this.port,
                debug: false
            });

            await new Promise((resolve, reject) => {
                writer.flash(hexData, (error) => {
                    if (error) reject(error);
                    else resolve();
                });
            });

            // === 完了 ===
            emitProgress('done');

            // シリアル接続開始
            this.sensorType = sensorType;
            // sb2cpp / makerBoard 書込時にどのセンサー用ファームを焼くか判定するため
            // グローバルにも共有する。学習データのセンサー種別と同じ値を入れておく。
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.dataSensorType = sensorType;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            await this.startStreaming();

            // セットアップ完了後、自動でグラフウィンドウを開く
            // (ユーザーが手動で「グラフを開く」ブロックを実行する手間を省く)
            try {
                this.openChart();
                // チャート側のラベル/Y軸をセンサー種別に合わせる
                if (this.chartWindow && this.chartWindow.setSensorType) {
                    this.chartWindow.setSensorType(sensorType);
                }
            } catch (e) {
                console.warn('[TinyML] グラフウィンドウ自動起動に失敗:', e);
            }

        } catch (error) {
            console.error('[TinyML] Setup error:', error);
            emitProgress('error', error && error.message ? error.message : String(error));

            // エラー時はポートを確実に解放
            await this.stopStreaming();
        }
    }

    /**
     * makerBoard 書込ボタンから呼ばれる「センサー接続の一時停止」。
     *   - reader をキャンセル → port を close → port オブジェクトを返却
     *   - 返却された port は makerBoard 側で書込用に再 open される
     *   - 書込完了後の自動再接続はしない (ファームが置き換わるため再接続しても
     *     データ収集プロトコルでなくなる可能性が高い)
     *
     * 重要: `isStreaming` フラグは見ない。 _streamLoop が NetworkError 等で抜けた
     * ケースでは isStreaming=false なのにポートだけ開いたまま残ることがある。
     * ポートを握っていれば必ず解放する。
     */
    async pauseForWrite() {
        // 自インスタンスが握っているリソースに加え、グローバルストアの
        // heldPort / heldReader も候補にする (HMR などで古いインスタンスの
        // reader / port が残っているケースを救済するため)
        const shared = (typeof window !== 'undefined') ? window.TinyMLShared : null;
        const sharedPort = shared ? shared.heldPort : null;
        const sharedReader = shared ? shared.heldReader : null;
        const port = this.port || sharedPort;
        const reader = this.reader || sharedReader;

        if (!this.isStreaming && !port && !reader) {
            return null;
        }

        // フラグを落として _streamLoop を抜けさせる
        this.isStreaming = false;
        this.isCollecting = false;

        // === 重要: reader を先に cancel + releaseLock しないと port.close() が
        //     "Cannot cancel a locked stream" で失敗する。
        //     instance.reader と shared.heldReader 両方を試す。
        if (reader) {
            try { await reader.cancel(); } catch (e) { /* ignore */ }
            try { reader.releaseLock(); } catch (e) { /* ignore */ }
        }
        this.reader = null;

        // ポート close (open状態のときだけ)
        if (port) {
            try {
                if (port.readable || port.writable) {
                    await port.close();
                }
            } catch (e) {
                console.warn('[TinyML] pauseForWrite port close error:', e);
            }
        }

        // 状態リセット & グローバルストアもクリア
        this.port = null;
        this.dataBuffer = [];
        this.inferenceWindowBuffer = [];
        if (shared) {
            if (shared.heldPort === port) shared.heldPort = null;
            if (shared.heldReader === reader) shared.heldReader = null;
        }

        return port;
    }

    /**
     * 既に書き込み済みの Pro Mini にシリアルだけ再接続する。
     * 「USBケーブルを抜いてしまった」「ストリーミングが切れた」のような時に
     * ファーム再書き込みを省いて素早く復帰させるためのブロック。
     *
     * 動作:
     *   1. もし既存ストリーミング中なら停止
     *   2. navigator.serial.getPorts() で過去に承認済みのポートを探す
     *      ・1個以上見つかれば末尾(=最後に承認したもの)を試す
     *      ・無ければ requestPort() でユーザーに選んでもらう
     *   3. open + startStreaming
     *   4. 既存ポートでの open が失敗したらピッカーへフォールバック
     */
    async reconnectSensor() {
        if (!('serial' in navigator)) {
            alert('このブラウザはWeb Serial APIに対応していません。Google Chromeを使用してください。');
            return;
        }

        // 既存接続を念のため停止
        if (this.isStreaming) {
            console.log('[TinyML] 既存の接続を停止します...');
            try {
                await this.stopStreaming();
                await new Promise(resolve => setTimeout(resolve, 500));
            } catch (e) {
                console.warn('[TinyML] 停止中にエラー(続行します):', e);
            }
        }

        let pickerUsed = false;
        try {
            // まず承認済みポートを試す
            let port = null;
            const authorized = await navigator.serial.getPorts();
            if (authorized.length > 0) {
                // 末尾を採用(通常 Pro Mini 1台運用が想定)
                port = authorized[authorized.length - 1];
                console.log(`[TinyML] 承認済みポート(${authorized.length}個中の末尾)で再接続を試みます...`);
            } else {
                console.log('[TinyML] 承認済みポートなし。選択ダイアログを開きます...');
                port = await navigator.serial.requestPort();
                pickerUsed = true;
            }

            this.port = port;
            // sensorType を保持しておく(setupSensor 経由でないので明示)
            if (!this.sensorType) this.sensorType = 'accelerometer';

            try {
                await this.startStreaming();
            } catch (openErr) {
                // 承認済みポートで失敗 → 物理的に違うポートかもしれない
                // ピッカーへフォールバック
                if (pickerUsed) throw openErr;  // 既にピッカー使ってたら諦める
                console.warn('[TinyML] 承認済みポートでの open に失敗。ピッカーに切り替えます:', openErr);
                this.port = await navigator.serial.requestPort();
                pickerUsed = true;
                await this.startStreaming();
            }

            console.log('[TinyML] ✅ 再接続成功');
            alert('センサー再接続OK！データ収集に進めます');
        } catch (error) {
            console.error('[TinyML] reconnect error:', error);
            // ユーザーがピッカーをキャンセルしたケース
            if (error && error.name === 'NotFoundError') {
                alert('ポートが選択されませんでした');
            } else {
                alert(
                    '再接続に失敗しました: ' + (error && error.message ? error.message : error) + '\n\n' +
                    'USBケーブルを一度抜き差ししてから、もう一度試してください。\n' +
                    'それでも繋がらないときは「[センサー]をセットアップ」ブロックでファームを書き直してください'
                );
            }
            await this.stopStreaming();
        }
    }

    /**
     * データ収集用Arduinoプログラム生成
     */
    generateDataCollectionProgram(sensorType) {
        if (sensorType === 'accelerometer') {
            return `
/*
 * TinyML データ収集プログラム (加速度センサー)
 * 自動生成日時: ${new Date().toISOString()}
 */

#include <MMA7660.h>

MMA7660 accelemeter;
float ax, ay, az;

void setup() {
    Serial.begin(115200);
    accelemeter.init();

    // 起動メッセージ
    Serial.println("TINYML_ACCEL_MODE");
    delay(100);
}

void loop() {
    // 加速度センサー読み取り
    accelemeter.getAcceleration(&ax, &ay, &az);

    // CSV形式で送信（パースしやすい）
    Serial.print(ax, 4);  // 小数点以下4桁
    Serial.print(",");
    Serial.print(ay, 4);
    Serial.print(",");
    Serial.println(az, 4);

    delay(50);  // 20Hz sampling
}
`;
        }

        if (sensorType === 'microphone') {
            // Grove Analog Microphone (Port3 = board.GROVE_CON3_SIG)
            //
            // 設計: 50ms ごとに「包絡線3チャネル」を 1 行送信する。
            //   x = RMS  (AC成分の二乗平均平方根を 0..1 に正規化)
            //   y = ZCR  (ゼロ交差率: AC符号反転回数 / サンプル数)
            //   z = Peak (AC成分の最大絶対値を 0..1 に正規化)
            // こうしておくと VM 側の dataBuffer / 特徴量抽出 / モデル / Arduino側
            // ヘルパは加速度センサー用のままで動く。
            //
            // 20Hz の出力レートは加速度センサーと揃え、特徴量計算 (window=30)
            // が 1.5 秒分のパターンを見るのを維持する。
            return `
/*
 * TinyML データ収集プログラム (Grove Analog Microphone, Port3)
 * 自動生成日時: ${new Date().toISOString()}
 *
 * 出力 1 行 = 50ms ぶんの包絡線
 *   x: RMS (0..1)
 *   y: ZCR (0..1)
 *   z: Peak (0..1)
 */

// このスケッチは sb2cpp 経由ではなく直接ビルドサーバーへ送られるため、
// 通常 sb2cpp 側 prelude にある MakerBoard インスタンス宣言を自前で持つ必要がある
// (user program 側の prelude と同じ並び順)
#include <Wire.h>
#include <MakerBoard.h>

MakerBoard board;

// 注意: board.GROVE_CON3_SIG は **関数内でのみ** 参照する。
// グローバル const での初期化は、もし board のコンストラクタ実行後に
// GROVE_CON3_SIG が決まる実装だと静的初期化順序問題で未初期化値を読みうるため避ける。
// kurikit_makerBoard/index.js の pin() ヘルパや analogRead スニペットも
// 必ず関数本体内で board.GROVE_CON*_SIG を参照する流儀。

void setup() {
    Serial.begin(115200);
    pinMode(board.GROVE_CON3_SIG, INPUT);
    Serial.println("TINYML_MIC_MODE");
    delay(100);
}

// 50ms 間にできるだけ多くの analogRead を回し、その間の RMS / ZCR / Peak を返す。
// 戻り値はすべて 0..1 に正規化 (10bit ADC, AC振幅 ±512 を 1.0 として扱う)。
void mic_sample_block(float* rms_out, float* zcr_out, float* peak_out) {
    const unsigned long BLOCK_MS = 50;
    int32_t sum = 0;
    int32_t sum_sq = 0;
    int16_t peak = 0;
    uint16_t zcr = 0;
    int16_t last_ac = 0;
    bool first = true;
    uint16_t count = 0;

    // 1パス目: DCバイアスを推定するため平均を集める
    unsigned long t0 = millis();
    // 直近サンプルを一旦集めながら平均も近似
    // (1パスで sum と sum_sq を両方持って後で AC = s - mean を再計算する)
    int16_t samples[200];
    while (millis() - t0 < BLOCK_MS && count < 200) {
        int s = analogRead(board.GROVE_CON3_SIG);
        samples[count++] = (int16_t)s;
        sum += s;
    }
    if (count == 0) {
        *rms_out = 0; *zcr_out = 0; *peak_out = 0;
        return;
    }
    int16_t mean = (int16_t)(sum / count);

    for (uint16_t i = 0; i < count; i++) {
        int16_t ac = samples[i] - mean;
        sum_sq += (int32_t)ac * ac;
        int16_t a = ac < 0 ? -ac : ac;
        if (a > peak) peak = a;
        if (!first) {
            if ((last_ac <= 0 && ac > 0) || (last_ac >= 0 && ac < 0)) zcr++;
        }
        last_ac = ac;
        first = false;
    }

    float rms = sqrt((float)sum_sq / count);
    *rms_out  = rms / 512.0f;            // 10bit AC振幅 ±512 を 1.0 と見做す
    *peak_out = (float)peak / 512.0f;
    *zcr_out  = (float)zcr / (float)count;
}

void loop() {
    float ax, ay, az;
    mic_sample_block(&ax, &ay, &az);

    Serial.print(ax, 4);
    Serial.print(",");
    Serial.print(ay, 4);
    Serial.print(",");
    Serial.println(az, 4);
}
`;
        }

        return '';
    }

    /**
     * シリアルストリーミング開始
     */
    async startStreaming() {
        if (!this.port) return;

        try {
            await this.port.open({
                baudRate: 115200,
                dataBits: 8,
                stopBits: 1,
                parity: 'none'
            });

            this.reader = this.port.readable.getReader();
            this.isStreaming = true;

            // HMR 等で古いインスタンスがポート + reader を握ったまま残るケースが
            // 起きうる。新しいインスタンスからは古い reader に到達できないので、
            // close を試みても "Cannot cancel a locked stream" になる。
            // そのため、port と reader 両方をグローバルストアに置いておく。
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.instance = this;
                window.TinyMLShared.heldPort = this.port;
                window.TinyMLShared.heldReader = this.reader;
            }

            // バックグラウンドで受信ループ開始
            this._streamLoop();

        } catch (error) {
            console.error('Serial open error:', error);
            throw error;
        }
    }

    /**
     * シリアル受信ループ
     */
    async _streamLoop() {
        const decoder = new TextDecoder();
        let buffer = '';
        
        try {
            while (this.isStreaming && this.reader) {
                try {
                    const { value, done } = await this.reader.read();
                    
                    if (done) {
                        console.log('[TinyML] ストリーム終了（done）');
                        break;
                    }
                    
                    buffer += decoder.decode(value, { stream: true });
                    
                    const lines = buffer.split('\n');
                    buffer = lines.pop() || '';
                    
                    for (const line of lines) {
                        this._processDataLine(line.trim());
                    }
                    
                } catch (error) {
                    if (error.name === 'NetworkError' || error.message.includes('cancel')) {
                        console.log('[TinyML] ストリームがキャンセルされました');
                        break;
                    } else {
                        console.error('[TinyML] Serial read error:', error);
                        break;
                    }
                }
            }
        } finally {
            console.log('[TinyML] ストリームループ終了');
        }
    }

    /**
     * センサー接続を停止するブロック
     */
    async stopSensor() {
        if (!this.isStreaming) {
            alert('センサーは接続されていません。');
            return;
        }
        
        console.log('[TinyML] センサー接続を停止します...');
        
        try {
            await this.stopStreaming();
            alert('センサー接続を停止しました。\nファームウェアの書き込みが可能になりました。');
        } catch (error) {
            console.error('[TinyML] 停止エラー:', error);
            alert(`停止中にエラーが発生しました: ${error.message}`);
        }
    }
    /**
     * データ収集ブロック
     */
    async collectData(args) {
        const label = Cast.toString(args.LABEL);
        const duration = Cast.toNumber(args.DURATION) * 1000; // ミリ秒
        const display = this._labelDisplay(label);

        if (!this.isStreaming) {
            alert('先にセンサーをセットアップしてください');
            return;
        }

        if (this.isCollecting) {
            alert('既にデータ収集中です。完了までお待ちください。');
            return;
        }

        this.isCollecting = true;

        // === 3-2-1 カウントダウン ===
        // 子供が「いつから動かすか」を予測できるよう、低音ビープ3回→高音ビープ1回で開始
        console.log(`[TinyML] ${display} の収集をはじめます。3-2-1 のあとに動かしてください`);
        for (let n = 3; n >= 1; n--) {
            console.log(`[TinyML] 　${n}...`);
            this._beep(500, 100);
            if (this.chartWindow) {
                this.chartWindow.setRecordingState({
                    state: 'countdown',
                    label: display,
                    secondsLeft: n
                });
            }
            await new Promise(r => setTimeout(r, 800));
        }
        console.log(`[TinyML] 　スタート！(${duration / 1000}秒間)`);
        this._beep(900, 200);
        if (this.chartWindow) {
            this.chartWindow.setRecordingState({
                state: 'recording',
                label: display,
                duration: duration / 1000
            });
        }

        const collectedData = [];
        const startTime = Date.now();

        // 「データ収集中はバッファに溜まっている古いデータを捨てる」
        // カウントダウン中に流れ込んでいた静止状態の余分なサンプルが、
        // 学習データに紛れ込むのを防ぐ
        this.dataBuffer.length = 0;

        return new Promise((resolve) => {
            const collectInterval = setInterval(() => {
                while (this.dataBuffer.length > 0) {
                    collectedData.push(this.dataBuffer.shift());
                }

                const elapsed = Date.now() - startTime;

                // 残り秒数を chart に通知（1Hz 程度の更新で十分）
                if (this.chartWindow) {
                    this.chartWindow.setRecordingState({
                        state: 'recording',
                        label: display,
                        secondsLeft: Math.max(0, Math.ceil((duration - elapsed) / 1000))
                    });
                }

                if (elapsed >= duration) {
                    clearInterval(collectInterval);

                    // データセットに追加 (この時の count を undo 用に記録)
                    if (!this.datasets.has(label)) {
                        this.datasets.set(label, []);
                    }
                    this.datasets.get(label).push(...collectedData);
                    this.lastCollectionRecord = {
                        label: label,
                        count: collectedData.length
                    };

                    this.isCollecting = false;

                    // 終了ビープ（成功示唆の上昇調)
                    this._beep(1100, 80);
                    setTimeout(() => this._beep(1400, 120), 90);
                    if (this.chartWindow) {
                        this.chartWindow.setRecordingState({
                            state: 'done',
                            label: display,
                            justCollected: collectedData.length,
                            total: this.datasets.get(label).length
                        });
                        // 2秒後にオーバーレイを消す
                        setTimeout(() => {
                            if (this.chartWindow && !this.isCollecting) {
                                this.chartWindow.setRecordingState({ state: 'idle' });
                            }
                        }, 2000);
                    }

                    console.log(`[TinyML] ✅ ${display}: ${collectedData.length}サンプル収集完了 (合計: ${this.datasets.get(label).length})`);
                    console.log(`[TinyML] 　もし動かし間違えたら「さっきの収集を取り消す」ブロックで取り消せます`);

                    resolve();
                }
            }, 100);
        });
    }

    /**
     * 直前の collectData をなかったことにする
     */
    undoLastCollection() {
        if (!this.lastCollectionRecord) {
            alert('取り消せる収集がありません');
            return;
        }
        const { label, count } = this.lastCollectionRecord;
        const samples = this.datasets.get(label);
        if (!samples || samples.length < count) {
            alert('データが既に変更されているため取り消せません');
            this.lastCollectionRecord = null;
            return;
        }
        samples.splice(samples.length - count, count);
        const display = this._labelDisplay(label);
        console.log(`[TinyML] ↩️ ${display} の最後の ${count} サンプルを取り消しました (残り: ${samples.length})`);
        this.lastCollectionRecord = null;
    }

    /**
     * 特定ラベルのデータだけ全削除
     */
    clearLabel(args) {
        const label = Cast.toString(args.LABEL);
        const display = this._labelDisplay(label);
        if (!this.datasets.has(label) || this.datasets.get(label).length === 0) {
            alert(`${display} のデータはありません`);
            return;
        }
        const before = this.datasets.get(label).length;
        const confirmed = confirm(`${display} のデータ ${before} 件を全部消しますか？\n他のラベルのデータは残ります`);
        if (!confirmed) return;
        this.datasets.delete(label);
        // 取り消し履歴がこのラベル分なら無効化
        if (this.lastCollectionRecord && this.lastCollectionRecord.label === label) {
            this.lastCollectionRecord = null;
        }
        console.log(`[TinyML] 🗑️ ${display} のデータ ${before} 件を削除しました`);
    }

    /**
     * ラベルに名前をつける
     */
    setLabelName(args) {
        const label = Cast.toString(args.LABEL);
        const name = Cast.toString(args.NAME).trim();
        if (!name) {
            this.labelNames.delete(label);
            console.log(`[TinyML] ラベル${label} の名前を消しました`);
            return;
        }
        this.labelNames.set(label, name);
        console.log(`[TinyML] 🏷️ ラベル${label} を「${name}」と名づけました`);
    }

    /**
     * ラベルの名前を取得（未設定なら空文字）
     */
    getLabelName(args) {
        const label = Cast.toString(args.LABEL);
        return this.labelNames.get(label) || '';
    }

    /**
     * データ収集量のバランスチェック (学習前に呼ぶと安心)
     * 各ラベルの状態を文字列で返す
     */
    checkDataBalance() {
        if (this.datasets.size === 0) {
            return 'データなし。まずは収集してください';
        }
        // 必要最低サンプル数(50): trainModel と同じ閾値
        const MIN_SAMPLES = 50;
        const parts = [];
        let okCount = 0;
        let lowCount = 0;
        for (const [label, samples] of this.datasets.entries()) {
            const display = this._labelDisplay(label);
            const n = samples.length;
            if (n >= MIN_SAMPLES) {
                parts.push(`✅ ${display}: ${n}`);
                okCount++;
            } else {
                parts.push(`⚠️ ${display}: ${n}(あと${MIN_SAMPLES - n})`);
                lowCount++;
            }
        }
        const head = lowCount === 0
            ? `OK (${okCount}クラス揃ってます): `
            : `たりないクラスが${lowCount}個あります: `;
        return head + parts.join(', ');
    }

    /**
     * データ数取得
     */
    getDataCount(args) {
        const label = Cast.toString(args.LABEL);
        const count = this.datasets.has(label) ? this.datasets.get(label).length : 0;
        return count;
    }

    /**
     * 現在のセンサー値取得（デバッグ用）
     */
    getCurrentSensorValue(args) {
        const axis = args.AXIS;
        return this.currentData[axis].toFixed(3);
    }

    /**
     * シリアルストリーミング停止
     */
    async stopStreaming() {
        console.log('[TinyML] ストリーミング停止処理開始...');
        
        this.isStreaming = false;
        this.isCollecting = false;
        
        try {
            // 1. Readerのキャンセルと解放
            //    this.reader が null でもグローバルに残っている可能性 (HMR等)
            const sharedForStop = (typeof window !== 'undefined') ? window.TinyMLShared : null;
            const sharedReader = sharedForStop ? sharedForStop.heldReader : null;
            const readerToClose = this.reader || sharedReader;
            if (readerToClose) {
                console.log('[TinyML] Readerをキャンセル中...');
                try {
                    await readerToClose.cancel();
                } catch (e) {
                    console.warn('[TinyML] Reader cancel error:', e);
                }

                try {
                    readerToClose.releaseLock();
                } catch (e) {
                    console.warn('[TinyML] Reader release error:', e);
                }

                this.reader = null;
                if (sharedForStop && sharedForStop.heldReader === readerToClose) {
                    sharedForStop.heldReader = null;
                }
                console.log('[TinyML] Readerを解放しました');
            }

            // 2. ポートのクローズ (this.port が null でもグローバルストアに残っている可能性あり)
            const sharedHeld = sharedForStop ? sharedForStop.heldPort : null;
            const portToClose = this.port || sharedHeld;
            if (portToClose) {
                console.log('[TinyML] ポートをクローズ中...');
                try {
                    if (portToClose.readable || portToClose.writable) {
                        await portToClose.close();
                    }
                } catch (e) {
                    console.warn('[TinyML] Port close error:', e);
                }

                this.port = null;
                if (sharedForStop && sharedForStop.heldPort === portToClose) {
                    sharedForStop.heldPort = null;
                }
                console.log('[TinyML] ポートを解放しました');
            }
            // 3. バッファのクリア
            this.dataBuffer = [];
            this.inferenceWindowBuffer = [];
            
            console.log('[TinyML] ストリーミング停止完了');                        

        } catch (error) {
            console.error('[TinyML] Stop streaming error:', error);
            
            // エラーが発生してもリソースを強制解放
            this.reader = null;
            this.port = null;
            this.dataBuffer = [];
            this.inferenceWindowBuffer = [];
            throw error;
        } finally {
            // 3. バッファのクリア
            this.dataBuffer = [];
            this.inferenceWindowBuffer = [];
            
            this.chartWindow.stop();
            console.log('[TinyML] ストリーミング停止完了');
        }
    }
        /**
     * 特徴量抽出（加速度センサー用）
     * @param {Array} window - センサーデータの窓 [{x, y, z, timestamp}, ...]
     * @returns {Array} - 10次元特徴量ベクトル
     */
    extractFeatures(window) {
        if (!window || window.length === 0) {
            return new Array(17).fill(0);  // 10→16→17次元に拡張
        }

        const x = window.map(d => d.x);
        const y = window.map(d => d.y);
        const z = window.map(d => d.z);
        
        const features = [];
        
        // === 既存特徴量 (0-9) ===
        // X軸統計量
        features.push(this._mean(x));      // 0
        features.push(this._std(x));       // 1
        
        // Y軸統計量
        features.push(this._mean(y));      // 2
        features.push(this._std(y));       // 3
        
        // Z軸統計量
        features.push(this._mean(z));      // 4
        features.push(this._std(z));       // 5
        
        // 合成加速度
        const magnitude = window.map(d => 
            Math.sqrt(d.x * d.x + d.y * d.y + d.z * d.z)
        );
        features.push(this._mean(magnitude));  // 6
        features.push(this._std(magnitude));   // 7
        
        // ゼロ交差率
        features.push(this._zeroCrossingRate(x));  // 8
        features.push(this._zeroCrossingRate(y));  // 9
        
        // === 新規特徴量 (10-15) ===
        
        // 10-11: ピーク数（振動の激しさ）
        features.push(this._countPeaks(x));
        features.push(this._countPeaks(y));
        
        // 12: 範囲（最大-最小）
        features.push(Math.max(...magnitude) - Math.min(...magnitude));
        
        // 13: エネルギー（二乗和の平均）
        const energy = magnitude.reduce((sum, val) => sum + val * val, 0) / magnitude.length;
        features.push(energy);
        
        // 14: 中央値（ロバストな中心傾向）
        features.push(this._median(magnitude));
        
        // 15: IQR（四分位範囲 - 外れ値に強い）
        features.push(this._iqr(magnitude));

        // 16: 強い衝撃ピーク数（合成加速度ベース、不応期付き）
        //    クリック=1, ダブルクリック=2, なでる=0, ゆする=多 を直接識別する目的の特徴量
        features.push(this._countStrongMagnitudePeaks(magnitude));

        return features;
    }

    /**
     * 強い衝撃ピーク数（クリック vs ダブルクリック識別用）
     *
     * 通常の _countPeaks より閾値を高くし、合成加速度に対して評価する。
     * 連続したサンプルが同じ衝撃の余韻で再カウントされないよう、不応期(refractory)を設ける。
     *
     * - 閾値: mean + max(std * 1.5, 0.2G)
     * - 不応期: 3サンプル（150ms @20Hz）
     * - 返り値: 整数カウント (0, 1, 2, ...)。x100 スケーリングは行わない
     *   (ファーム側 C++ では count*100 を返してスケール一致)
     */
    _countStrongMagnitudePeaks(magnitude) {
        if (magnitude.length < 3) return 0;
        const mean = this._mean(magnitude);
        const std = this._std(magnitude);
        const threshold = mean + Math.max(std * 1.5, 0.2);
        const REFRACTORY = 3;

        let count = 0;
        let lastPeakIdx = -REFRACTORY;
        for (let i = 1; i < magnitude.length - 1; i++) {
            if (magnitude[i] > magnitude[i - 1] &&
                magnitude[i] > magnitude[i + 1] &&
                magnitude[i] > threshold) {
                if (i - lastPeakIdx >= REFRACTORY) {
                    count++;
                    lastPeakIdx = i;
                }
            }
        }
        return count;
    }

    /**
     * データ拡張: 元の窓に小さな摂動を与えた新しい窓を生成する。
     * 子供が各クラス数秒しか収集しないユースケースで、決定木が境界付近の
     * しきい値に過敏に反応しないように学習データの分布を広げる狙い。
     *
     * 3 種の摂動を毎回ランダムに組み合わせる:
     *   1. 時間シフト: 窓開始位置を ±3 サンプル(=±0.15s @20Hz)ずらす
     *      (動作のタイミングずれに対するロバスト性)
     *   2. 振幅スケーリング: 窓全体に係数 0.9〜1.1 を掛ける
     *      (センサー個体差・装着位置差を吸収)
     *   3. ガウシアンノイズ: 各サンプルに N(0, σ=0.02g) を加算
     *      (静的計測ノイズの再現)
     *
     * 注意: 特徴量計算は変更せず、入力側を摂動するだけ。ファーム側の
     *       extractFeatures C++ 実装との bit-exact 整合は崩れない。
     */
    _augmentWindow(samples, baseStart, windowSize) {
        // 時間シフト ±3 サンプル
        const maxShift = 3;
        const shift = Math.floor(Math.random() * (2 * maxShift + 1)) - maxShift;
        let safeStart = baseStart + shift;
        if (safeStart < 0) safeStart = 0;
        if (safeStart + windowSize > samples.length) safeStart = samples.length - windowSize;

        // 振幅スケーリング 0.9〜1.1（窓内で一定）
        const ampScale = 0.9 + Math.random() * 0.2;

        // Box-Muller でガウシアンノイズ生成
        const noiseSigma = 0.02;
        const gauss = () => {
            const u1 = Math.random() || 1e-9;
            const u2 = Math.random();
            return Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
        };

        const out = new Array(windowSize);
        for (let k = 0; k < windowSize; k++) {
            const s = samples[safeStart + k];
            out[k] = {
                x: s.x * ampScale + gauss() * noiseSigma,
                y: s.y * ampScale + gauss() * noiseSigma,
                z: s.z * ampScale + gauss() * noiseSigma
            };
        }
        return out;
    }

    /**
     * ピーク数カウント（ノイズ耐性改善版）
     */
    _countPeaks(arr) {
        if (arr.length < 3) return 0;

        const mean = this._mean(arr);
        const std = this._std(arr);

        // 最小閾値を設定（stdが小さい時のノイズ対策）
        // stdの半分か、最低0.1（0.1G相当）のうち大きい方を使用
        const minThresholdOffset = 0.1;  // 0.1G
        const thresholdOffset = Math.max(std * 0.5, minThresholdOffset);
        const threshold = mean + thresholdOffset;

        let peaks = 0;
        for (let i = 1; i < arr.length - 1; i++) {
            if (arr[i] > arr[i-1] && arr[i] > arr[i+1] && arr[i] > threshold) {
                peaks++;
            }
        }

        return peaks / arr.length;  // 正規化
    }

    /**
     * 中央値
     */
    _median(arr) {
        if (arr.length === 0) return 0;
        const sorted = [...arr].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        return sorted.length % 2 === 0 
            ? (sorted[mid - 1] + sorted[mid]) / 2 
            : sorted[mid];
    }

    /**
     * 四分位範囲（IQR）
     */
    _iqr(arr) {
        if (arr.length === 0) return 0;
        const sorted = [...arr].sort((a, b) => a - b);
        const q1Index = Math.floor(sorted.length * 0.25);
        const q3Index = Math.floor(sorted.length * 0.75);
        return sorted[q3Index] - sorted[q1Index];
    }
    /**
     * 平均値計算
     */
    _mean(arr) {
        if (arr.length === 0) return 0;
        const sum = arr.reduce((a, b) => a + b, 0);
        return sum / arr.length;
    }

    /**
     * 標準偏差計算
     */
    _std(arr) {
        if (arr.length === 0) return 0;
        const mean = this._mean(arr);
        const variance = arr.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / arr.length;
        return Math.sqrt(variance);
    }

    /**
     * ゼロ交差率計算
     */
    _zeroCrossingRate(arr) {
        if (arr.length <= 1) return 0;
        let crossings = 0;
        for (let i = 1; i < arr.length; i++) {
            if ((arr[i] > 0) !== (arr[i-1] > 0)) {
                crossings++;
            }
        }
        return crossings / (arr.length - 1);
    }

    /**
     * データセットを「生窓のリファレンス」に変換する。
     * 特徴量抽出やデータ拡張は呼び出し側で train/val 分割後に行う。
     * これにより、データ拡張で生成された近似サンプルが訓練と検証の両側に
     * 混入する leak を防ぎ、検証精度を honest な数字にする。
     * @returns {Object} {windowRefs: Array<{samples, startIdx}>, labels: Array<number>, windowSize: number}
     */
    prepareTrainingData() {
        const windowRefs = [];
        const labels = [];
        const windowSize = 30;
        const stepSize = 15;  // 50% オーバーラップ

        this.labelMap.clear();

        // ラベル番号順にソート（"1", "2", "3", ...）
        const sortedLabels = Array.from(this.datasets.keys()).sort((a, b) => {
            return parseInt(a) - parseInt(b);
        });

        for (let i = 0; i < sortedLabels.length; i++) {
            const labelName = sortedLabels[i];
            const samples = this.datasets.get(labelName);

            if (samples.length === 0) continue;

            // ラベル番号をそのままクラスインデックスに（1→0, 2→1, ...）
            this.labelMap.set(labelName, i);

            for (let j = 0; j <= samples.length - windowSize; j += stepSize) {
                windowRefs.push({ samples, startIdx: j });
                labels.push(i);
            }
        }

        console.log(`[TinyML] 元データ準備: ${windowRefs.length}窓, ${this.labelMap.size}クラス`);
        console.log(`[TinyML] ラベルマッピング:`, Object.fromEntries(this.labelMap));

        return { windowRefs, labels, windowSize };
    }

    /**
     * 窓リファレンスのリストから (特徴量, ラベル) のペアを生成する。
     * augmentationCount > 0 なら各窓につき +augmentationCount 個の摂動済み
     * 特徴量を追加する。検証データには augmentationCount=0 を渡して
     * オリジナルだけ評価する。
     */
    _extractFeaturesFromRefs(windowRefs, labels, windowSize, augmentationCount) {
        const features = [];
        const expandedLabels = [];
        for (let i = 0; i < windowRefs.length; i++) {
            const { samples, startIdx } = windowRefs[i];
            const lbl = labels[i];
            const origWindow = samples.slice(startIdx, startIdx + windowSize);
            features.push(this.extractFeatures(origWindow));
            expandedLabels.push(lbl);
            for (let a = 0; a < augmentationCount; a++) {
                const augWindow = this._augmentWindow(samples, startIdx, windowSize);
                features.push(this.extractFeatures(augWindow));
                expandedLabels.push(lbl);
            }
        }
        return { features, labels: expandedLabels };
    }

    /**
     * 混同行列を計算する。
     * @returns {{matrix: number[][], labelOrder: string[]}}
     *   matrix[trueClass][predClass] = カウント
     */
    _confusionMatrix(yTrue, yPred, numClasses) {
        const matrix = Array.from({ length: numClasses }, () => new Array(numClasses).fill(0));
        for (let i = 0; i < yTrue.length; i++) {
            matrix[yTrue[i]][yPred[i]]++;
        }
        // ラベル名をクラスインデックス順で取得（命名済みなら名前を、未命名なら番号を）
        const labelOrder = [];
        for (let c = 0; c < numClasses; c++) {
            for (const [name, idx] of this.labelMap.entries()) {
                if (idx === c) {
                    labelOrder.push(this._labelDisplay(name));
                    break;
                }
            }
        }
        return { matrix, labelOrder };
    }
    /**
     * モデル学習ブロック
     */
    async trainModel() {
        // データセットチェック（より詳細に）
        if (this.datasets.size === 0) {
            alert('訓練データがありません。先にデータを収集してください。');
            return;
        }
        
        // 各ラベルのサンプル数チェック
        const labelInfo = [];
        for (const [label, samples] of this.datasets.entries()) {
            labelInfo.push({ label, count: samples.length });
        }
        
        console.log('[TinyML] データセット情報:', labelInfo);
        
        // サンプル数が少なすぎるラベルをチェック
        const insufficientLabels = labelInfo.filter(info => info.count < 50);
        if (insufficientLabels.length > 0) {
            const msg = insufficientLabels.map(info =>
                `  ${this._labelDisplay(info.label)}: ${info.count}サンプル`
            ).join('\n');
            alert(
                '一部のラベルのデータが不足しています：\n' + msg + '\n\n' +
                '各ラベル最低3秒以上のデータを収集してください。'
            );
            return;
        }
        
        if (this.datasets.size < 2) {
            alert('最低2つのラベルが必要です。');
            return;
        }
        
        console.log('[TinyML] モデル訓練開始...');
        
        try {
            // 古いモデルと状態をクリア
            this.model = null;
            this.labelMap.clear();
            this.trainingAccuracy = 0;
            this.validationAccuracy = 0;
            this.lastPrediction = null;
            this.lastConfidence = 0;
            
            // 訓練データ準備（生窓のリファレンスを返す。特徴抽出と拡張は分割後に行う）
            const { windowRefs, labels: refLabels, windowSize } = this.prepareTrainingData();

            console.log('[TinyML] 準備完了:', {
                総窓数: windowRefs.length,
                クラス数: this.labelMap.size,
                ラベルマッピング: Object.fromEntries(this.labelMap)
            });

            if (windowRefs.length < 10) {
                alert(
                    '訓練データが不足しています。\n' +
                    `現在: ${windowRefs.length}窓\n` +
                    '必要: 最低10窓\n\n' +
                    '各ラベル最低5秒以上のデータを収集してください。'
                );
                return;
            }

            // 生窓レベルでシャッフル & 80/20 分割 → 拡張の leak を防ぐ
            const shuffled = this._shuffleData(windowRefs, refLabels);
            const splitIndex = Math.floor(shuffled.features.length * 0.8);
            const trainRefs = shuffled.features.slice(0, splitIndex);
            const trainRefLabels = shuffled.labels.slice(0, splitIndex);
            const valRefs = shuffled.features.slice(splitIndex);
            const valRefLabels = shuffled.labels.slice(splitIndex);

            // 訓練側のみデータ拡張（5倍）。検証は生のまま評価して honest な数字を出す
            const AUGMENTATION_COUNT = 5;
            const trainData = this._extractFeaturesFromRefs(
                trainRefs, trainRefLabels, windowSize, AUGMENTATION_COUNT
            );
            const valData = this._extractFeaturesFromRefs(
                valRefs, valRefLabels, windowSize, 0
            );

            console.log('[TinyML] データ分割:', {
                訓練元窓: trainRefs.length,
                訓練拡張後: trainData.features.length,
                検証: valData.features.length
            });

            // MLP で学習 (17 → 16 hidden(ReLU) → N_classes)
            //   特徴量に過依存しない、汎化性向上のためのモデル選択。
            //   旧モデル(SimpleDecisionTree)に戻したい場合は次の一行を差し替え:
            //   this.model = new SimpleDecisionTree(5, 5);
            this.model = new SimpleMLP(17, 16, this.labelMap.size, {
                dropout: 0.2,
                l2: 0.001,
                lr: 0.01,
                momentum: 0.9,
                maxEpochs: 200,
                batchSize: 16,
                patience: 25
            });
            console.log('[TinyML] MLP学習開始...');
            this.model.train(trainData.features, trainData.labels);
            console.log('[TinyML] MLP学習終了 (epochs実行=' +
                (this.model.trainHistory.length) + ')');

            // 精度評価
            this.trainingAccuracy = this.model.score(trainData.features, trainData.labels) * 100;
            this.validationAccuracy = this.model.score(valData.features, valData.labels) * 100;

            console.log(`[TinyML] 訓練精度: ${this.trainingAccuracy.toFixed(1)}%`);
            console.log(`[TinyML] 検証精度: ${this.validationAccuracy.toFixed(1)}% (leak なしの honest 値)`);

            // 混同行列を検証セットで計算してログ出力
            const valPreds = valData.features.map(f => this.model.predict(f));
            const cm = this._confusionMatrix(valData.labels, valPreds, this.labelMap.size);
            console.log('[TinyML] 検証セットの混同行列 (行=正解クラス, 列=予測クラス):');
            const tableObj = {};
            for (let r = 0; r < cm.matrix.length; r++) {
                const row = {};
                for (let c = 0; c < cm.matrix[r].length; c++) {
                    row[`pred:${cm.labelOrder[c]}`] = cm.matrix[r][c];
                }
                tableObj[`true:${cm.labelOrder[r]}`] = row;
            }
            console.table(tableObj);
            // 平文ダンプ（DevTools の console.table が貼り付けにくいので）
            const colHeader = '         ' + cm.labelOrder.map(n => `pred${n}`.padStart(7)).join(' ');
            console.log('[TinyML] 混同行列(平文):\n' + colHeader);
            for (let r = 0; r < cm.matrix.length; r++) {
                const rowStr = `true${cm.labelOrder[r]}`.padStart(8) + ' ' +
                    cm.matrix[r].map(v => String(v).padStart(7)).join(' ');
                console.log(rowStr);
            }
            // クラス別リコール（そのクラスを正しく拾えた割合）
            console.log('[TinyML] クラス別リコール:');
            for (let r = 0; r < cm.matrix.length; r++) {
                const total = cm.matrix[r].reduce((a, b) => a + b, 0);
                const correct = cm.matrix[r][r];
                const recall = total > 0 ? (correct / total * 100).toFixed(1) : 'N/A';
                console.log(`  ${cm.labelOrder[r]}: ${recall}% (${correct}/${total})`);
            }
            
            // === 重要：共有オブジェクトに保存 ===
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.model = this.model;
                window.TinyMLShared.labelMap = this.labelMap;
                window.TinyMLShared.trainingAccuracy = this.trainingAccuracy;
                window.TinyMLShared.validationAccuracy = this.validationAccuracy;
                window.TinyMLShared.isModelTrained = true;
                
                console.log('[TinyML] モデルを共有オブジェクトに保存しました');
                console.log('[TinyML] 共有オブジェクト:', {
                    model: !!window.TinyMLShared.model,
                    labelMapSize: window.TinyMLShared.labelMap.size,
                    accuracy: window.TinyMLShared.validationAccuracy
                });
            }
            
            // 結果の評価とアドバイス
            let advice = '';
            if (this.validationAccuracy < 60) {
                advice = '\n\n⚠️ 精度が低すぎます。以下を確認してください：\n' +
                         '・各動作の違いが明確か\n' +
                         '・各ラベルのデータ量が十分か（最低5秒以上）\n' +
                         '・データ収集時の動作が一貫しているか';
            } else if (this.validationAccuracy < 80) {
                advice = '\n\n各ラベルのデータを増やすと精度が向上する可能性があります。';
            } else {
                advice = '\n\n精度は良好です！';
            }
            
            alert(
                `学習完了！\n\n` +
                `訓練精度: ${this.trainingAccuracy.toFixed(1)}%\n` +
                `検証精度: ${this.validationAccuracy.toFixed(1)}%\n` +
                `クラス数: ${this.labelMap.size}` +
                advice
            );
            
        } catch (error) {
            console.error('[TinyML] 学習エラー:', error);
            alert(`学習中にエラーが発生しました: ${error.message}`);
            
            // エラー時は状態をクリア
            this.model = null;
            this.labelMap.clear();
            this.trainingAccuracy = 0;
            this.validationAccuracy = 0;
            
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.model = null;
                window.TinyMLShared.labelMap = null;
                window.TinyMLShared.isModelTrained = false;
            }
        }
    }

    /**
     * データとモデルのクリア（修正版）
     */
    clearData() {
        const confirmed = confirm(
            '収集した全てのデータを削除しますか？\n' +
            '※学習済みモデルも削除されます'
        );
        
        if (confirmed) {
            this.datasets.clear();
            this.model = null;
            this.labelMap.clear();
            this.labelNames.clear();
            this.lastCollectionRecord = null;
            this.trainingAccuracy = 0;
            this.validationAccuracy = 0;
            this.lastPrediction = null;
            this.lastConfidence = 0;
            this.lastPredictionTime = 0;

            // 共有オブジェクトもクリア
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.model = null;
                window.TinyMLShared.labelMap = null;
                window.TinyMLShared.trainingAccuracy = 0;
                window.TinyMLShared.validationAccuracy = 0;
                window.TinyMLShared.isModelTrained = false;
            }

            console.log('[TinyML] 全データと学習済みモデルを削除しました');
        }
    }

    /**
     * モデルのみクリア（修正版）
     */
    clearModel() {
        const confirmed = confirm('学習済みモデルを削除しますか？\n※データは保持されます');
        if (confirmed) {
            this.model = null;
            this.labelMap.clear();
            this.trainingAccuracy = 0;
            this.validationAccuracy = 0;
            this.lastPrediction = null;
            this.lastConfidence = 0;
            
            // 共有オブジェクトもクリア
            if (typeof window !== 'undefined' && window.TinyMLShared) {
                window.TinyMLShared.model = null;
                window.TinyMLShared.labelMap = null;
                window.TinyMLShared.trainingAccuracy = 0;
                window.TinyMLShared.validationAccuracy = 0;
                window.TinyMLShared.isModelTrained = false;
            }
            
            console.log('[TinyML] モデルを削除しました');
        }
    }
    /**
     * データシャッフル
     */
    _shuffleData(features, labels) {
        const indices = Array.from({ length: features.length }, (_, i) => i);
        
        // Fisher-Yates シャッフル
        for (let i = indices.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [indices[i], indices[j]] = [indices[j], indices[i]];
        }
        
        return {
            features: indices.map(i => features[i]),
            labels: indices.map(i => labels[i])
        };
    }

    /**
     * データセット情報表示（デバッグ用ブロック追加推奨）
     */
    showDatasetInfo() {
        if (this.datasets.size === 0) {
            return 'データなし';
        }

        const info = [];
        for (const [label, samples] of this.datasets.entries()) {
            info.push(`${this._labelDisplay(label)}: ${samples.length}サンプル`);
        }

        return info.join(', ');
    }

    /**
     * 精度取得
     */
    getAccuracy() {
        return this.validationAccuracy.toFixed(1);
    }

    /**
     * モデル訓練済みチェック
     */
    isModelTrained() {
        return this.model !== null;
    }

    /**
     * リアルタイム識別
     * バッファから最新50サンプルを使って推論
     */
    classify() {
        if (!this.model) {
            return 'モデル未訓練';
        }
        
        if (!this.isStreaming) {
            return 'センサー未接続';
        }
        
        const windowSize = 30;  // 学習時・Arduino側と統一
        const allData = [...this.inferenceWindowBuffer, ...this.dataBuffer];

        if (allData.length < windowSize) {
            return `データ不足(${allData.length}/${windowSize})`;
        }
        
        const window = allData.slice(-windowSize);
        const features = this.extractFeatures(window);
        const predictedClass = this.model.predict(features);

        // デバッグ: 特徴量を出力（PC側とArduino側の比較用）
        if (this.debugMode) {
            const featureNames = [
                'X_mean', 'X_std', 'Y_mean', 'Y_std', 'Z_mean', 'Z_std',
                'Mag_mean', 'Mag_std', 'X_zcr', 'Y_zcr',
                'X_peaks', 'Y_peaks', 'Mag_range', 'Mag_energy', 'Mag_median', 'Mag_iqr'
            ];
            console.log('[TinyML Debug] === PC側 特徴量 ===');
            features.forEach((f, i) => {
                const x100 = Math.round(f * 100);
                console.log(`  [${i}] ${featureNames[i]}: ${f.toFixed(4)} (x100: ${x100})`);
            });
            console.log(`  → 予測クラス: ${predictedClass} (表示: ${predictedClass + 1})`);
        }

        // モデル種別に応じた信頼度計算 (MLP: softmax確率, 決定木: 葉の分布)
        this.lastConfidence = this._calculateConfidence(this.model, features);
        this.lastPrediction = predictedClass + 1;  // ← 0始まり→1始まりに変換
        this.lastPredictionTime = Date.now();

        return this.lastPrediction;  // 1, 2, 3, 4, 5 を返す
    }

    /**
     * モデル別の信頼度計算 (0〜100%)
     *   - MLP: argmax クラスの softmax 確率
     *   - 決定木: ルートから葉まで辿って葉の分布から最頻クラス比率
     */
    _calculateConfidence(model, features) {
        if (!model) return 0;

        // === MLP の場合 ===
        if (typeof model.predictProba === 'function') {
            const probs = model.predictProba(features);
            let best = probs[0];
            for (let i = 1; i < probs.length; i++) if (probs[i] > best) best = probs[i];
            return best * 100;
        }

        // === 決定木の場合 ===
        let node = model.tree;
        if (!node) return 0;
        while (!node.isLeaf) {
            if (features[node.featureIndex] <= node.threshold) {
                node = node.left;
            } else {
                node = node.right;
            }
        }
        if (!node.distribution) return 0;
        const total = node.distribution.reduce((a, b) => a + b, 0);
        const max = Math.max(...node.distribution);
        return total > 0 ? (max / total) * 100 : 0;
    }

    /**
     * 識別信頼度取得
     */
    getConfidence() {
        return this.lastConfidence.toFixed(1);
    }

    /**
     * 識別結果の条件判定
     */
    isLabel(args) {
        const targetLabel = Cast.toNumber(args.LABEL);  // ← toString → toNumber
        
        if (!this.model) {
            return false;
        }
        
        if (Date.now() - this.lastPredictionTime < 1000 && this.lastPrediction) {
            return this.lastPrediction === targetLabel;
        }
        
        const currentPrediction = this.classify();
        return currentPrediction === targetLabel;
    }

    /**
     * データ行の処理
     */
    _processDataLine(line) {
        if (!line || line.startsWith('TINYML_')) return;
        
        const parts = line.split(',');
        if (parts.length !== 3) return;
        
        const x = parseFloat(parts[0]);
        const y = parseFloat(parts[1]);
        const z = parseFloat(parts[2]);
        
        if (isNaN(x) || isNaN(y) || isNaN(z)) return;
        
        const dataPoint = {
            x: x,
            y: y,
            z: z,
            timestamp: Date.now()
        };

        // データ収集用バッファ
        this.dataBuffer.push(dataPoint);
        if (this.dataBuffer.length > 100) {
            this.dataBuffer.shift();
        }

        // 推論用バッファ（常に最新30サンプルを保持）
        this.inferenceWindowBuffer.push(dataPoint);
        if (this.inferenceWindowBuffer.length > 30) {
            this.inferenceWindowBuffer.shift();
        }
        
        // 現在値更新
        this.currentData = dataPoint;
        
        // グラフ更新
        if (this.chartWindow) {
            this.chartWindow.addDataPoint(x, y, z);
        }
    }

    /**
     * 決定木をCコードに変換
     */
    generateDecisionTreeCode() {
        if (!this.model || !this.model.tree) {
            throw new Error('モデルが訓練されていません');
        }
        
        // ラベル名の配列を生成
        const labelNames = Array.from(this.labelMap.entries())
            .sort((a, b) => a[1] - b[1])  // インデックス順にソート
            .map(([name, _]) => name);
        
        const numClasses = labelNames.length;
        
        let code = `
    // TinyML 学習済みモデル（決定木）
    // 生成日時: ${new Date().toISOString()}
    // クラス数: ${numClasses}

    #define TINYML_NUM_CLASSES ${numClasses}
    #define TINYML_FEATURE_SIZE 17  // ← 10→16→17（強い衝撃ピーク数を追加）
    
    // ラベル名
    const char* tinyml_label_names[TINYML_NUM_CLASSES] = {
    ${labelNames.map(name => `    "${name}"`).join(',\n')}
    };

    `;

        // 決定木の再帰的なC関数生成
        code += this._generateTreeNodeCode(this.model.tree, 0);
        
        // メイン予測関数
        code += `
    // 予測関数
    int tinyml_predict(float features[TINYML_FEATURE_SIZE]) {
        return decision_node_0(features);
    }

    // ラベル名取得
    const char* tinyml_get_label_name(int class_index) {
        if (class_index >= 0 && class_index < TINYML_NUM_CLASSES) {
            return tinyml_label_names[class_index];
        }
        return "unknown";
    }
    `;

        return code;
    }

    /**
     * 決定木ノードのC関数生成（再帰）
     */
    _generateTreeNodeCode(node, nodeId) {
        let code = '';
        
        if (node.isLeaf) {
            // 葉ノード：クラスを返す
            code += `
    int decision_node_${nodeId}(float features[TINYML_FEATURE_SIZE]) {
        return ${node.predictedClass};
    }
    `;
        } else {
            // 内部ノード：分岐処理
            const leftId = nodeId * 2 + 1;
            const rightId = nodeId * 2 + 2;
            
            // 再帰的に子ノードのコード生成
            code += this._generateTreeNodeCode(node.left, leftId);
            code += this._generateTreeNodeCode(node.right, rightId);
            
            // 現在のノードの分岐コード
            code += `
    int decision_node_${nodeId}(float features[TINYML_FEATURE_SIZE]) {
        if (features[${node.featureIndex}] <= ${node.threshold.toFixed(6)}f) {
            return decision_node_${leftId}(features);
        } else {
            return decision_node_${rightId}(features);
        }
    }
    `;
        }
        
        return code;
    }

    /**
     * 特徴量抽出のCコード生成
     */
    generateFeatureExtractionCode() {
        return `
// 特徴量抽出関数（メモリ最適化版）

// 平均値計算
float tinyml_mean(float* data, int length) {
    if (length == 0) return 0.0f;
    float sum = 0.0f;
    for (int i = 0; i < length; i++) {
        sum += data[i];
    }
    return sum / length;
}

// 標準偏差計算
float tinyml_std(float* data, int length) {
    if (length == 0) return 0.0f;
    float mean = tinyml_mean(data, length);
    float variance = 0.0f;
    for (int i = 0; i < length; i++) {
        float diff = data[i] - mean;
        variance += diff * diff;
    }
    return sqrt(variance / length);
}

// ゼロ交差率計算
float tinyml_zero_crossing_rate(float* data, int length) {
    if (length <= 1) return 0.0f;
    int crossings = 0;
    for (int i = 1; i < length; i++) {
        if ((data[i] > 0) != (data[i-1] > 0)) {
            crossings++;
        }
    }
    return (float)crossings / (length - 1);
}

// センサーデータから特徴量を抽出（メモリ最適化版）
void tinyml_extract_features(float* buffer_x, float* buffer_y, float* buffer_z, 
                             int length, float* features) {
    // X軸統計量
    features[0] = tinyml_mean(buffer_x, length);
    features[1] = tinyml_std(buffer_x, length);
    
    // Y軸統計量
    features[2] = tinyml_mean(buffer_y, length);
    features[3] = tinyml_std(buffer_y, length);
    
    // Z軸統計量
    features[4] = tinyml_mean(buffer_z, length);
    features[5] = tinyml_std(buffer_z, length);
    
    // 合成加速度（スタック配列を使わず直接計算）
    float mag_sum = 0.0f;
    for (int i = 0; i < length; i++) {
        float mag = sqrt(buffer_x[i]*buffer_x[i] + 
                        buffer_y[i]*buffer_y[i] + 
                        buffer_z[i]*buffer_z[i]);
        mag_sum += mag;
    }
    float mag_mean = mag_sum / length;
    features[6] = mag_mean;
    
    // 合成加速度の標準偏差
    float mag_variance = 0.0f;
    for (int i = 0; i < length; i++) {
        float mag = sqrt(buffer_x[i]*buffer_x[i] + 
                        buffer_y[i]*buffer_y[i] + 
                        buffer_z[i]*buffer_z[i]);
        float diff = mag - mag_mean;
        mag_variance += diff * diff;
    }
    features[7] = sqrt(mag_variance / length);
    
    // ゼロ交差率
    features[8] = tinyml_zero_crossing_rate(buffer_x, length);
    features[9] = tinyml_zero_crossing_rate(buffer_y, length);
}
        `;
    }
    /**
     * 最適化版：特徴量抽出コード生成
     */
    generateOptimizedFeatureExtractionCode() {
        return `
// 特徴量抽出関数（16次元版・メモリ最適化）

// 基本統計関数
int16_t tinyml_mean_x100(int16_t* data, uint8_t length) {
    if (length == 0) return 0;
    int32_t sum = 0;
    for (uint8_t i = 0; i < length; i++) {
        sum += data[i];
    }
    return (int16_t)(sum / length);
}

int16_t tinyml_std_x100(int16_t* data, uint8_t length) {
    if (length == 0) return 0;
    int16_t mean = tinyml_mean_x100(data, length);
    int32_t variance = 0;
    for (uint8_t i = 0; i < length; i++) {
        int16_t diff = data[i] - mean;
        variance += (int32_t)diff * diff;
    }
    int32_t std_squared = variance / length;
    return (int16_t)sqrt((float)std_squared);
}

int16_t tinyml_zero_crossing_x100(int16_t* data, uint8_t length) {
    if (length <= 1) return 0;
    uint8_t crossings = 0;
    for (uint8_t i = 1; i < length; i++) {
        if ((data[i] > 0) != (data[i-1] > 0)) {
            crossings++;
        }
    }
    return (int16_t)((crossings * 100) / (length - 1));
}

// ピーク数カウント（ノイズ耐性改善版）
int16_t tinyml_count_peaks_x100(int16_t* data, uint8_t length) {
    if (length < 3) return 0;

    int16_t mean = tinyml_mean_x100(data, length);
    int16_t std = tinyml_std_x100(data, length);

    // 最小閾値を設定（stdが小さい時のノイズ対策）
    // stdの半分か、最低10（0.1G相当）のうち大きい方を使用
    int16_t min_threshold_offset = 10;  // 0.1G = 10 (x100)
    int16_t threshold_offset = (std / 2) > min_threshold_offset ? (std / 2) : min_threshold_offset;
    int16_t threshold = mean + threshold_offset;

    uint8_t peaks = 0;

    for (uint8_t i = 1; i < length - 1; i++) {
        if (data[i] > data[i-1] && data[i] > data[i+1] && data[i] > threshold) {
            peaks++;
        }
    }

    return (int16_t)((peaks * 100) / length);
}

// 範囲（最大-最小）
int16_t tinyml_range(int16_t* data, uint8_t length) {
    if (length == 0) return 0;
    
    int16_t min_val = data[0];
    int16_t max_val = data[0];
    
    for (uint8_t i = 1; i < length; i++) {
        if (data[i] < min_val) min_val = data[i];
        if (data[i] > max_val) max_val = data[i];
    }
    
    return max_val - min_val;
}

// エネルギー（二乗和の平均）
int16_t tinyml_energy_x100(int16_t* data, uint8_t length) {
    if (length == 0) return 0;
    
    int32_t energy = 0;
    for (uint8_t i = 0; i < length; i++) {
        int32_t val = data[i];
        energy += (val * val) / 100;
    }
    
    return (int16_t)(energy / length);
}

// 中央値（インプレースソート版・メモリ節約）
int16_t tinyml_median_x100(int16_t* data, uint8_t length) {
    if (length == 0) return 0;
    if (length == 1) return data[0];
    
    // 簡易選択ソート（length <= 50 なので十分高速）
    // 注意: この関数は元の配列を変更します
    for (uint8_t i = 0; i < length - 1; i++) {
        uint8_t min_idx = i;
        for (uint8_t j = i + 1; j < length; j++) {
            if (data[j] < data[min_idx]) {
                min_idx = j;
            }
        }
        if (min_idx != i) {
            int16_t temp = data[i];
            data[i] = data[min_idx];
            data[min_idx] = temp;
        }
    }
    
    uint8_t mid = length / 2;
    if (length % 2 == 0) {
        return (data[mid - 1] + data[mid]) / 2;
    } else {
        return data[mid];
    }
}

// IQR（四分位範囲）- ソート済み配列を前提
int16_t tinyml_iqr_x100(int16_t* sorted_data, uint8_t length) {
    if (length < 4) return 0;

    uint8_t q1_idx = length / 4;
    uint8_t q3_idx = (length * 3) / 4;

    return sorted_data[q3_idx] - sorted_data[q1_idx];
}

// 強い衝撃ピーク数（合成加速度ベース、不応期付き）
// クリック=1, ダブルクリック=2, なでる=0, ゆする=多 を識別する目的の特徴量
// 入力は x100 スケール、返り値は count * 100 (他特徴量とスケール統一)
int16_t tinyml_count_strong_peaks(int16_t* magnitude, uint8_t length) {
    if (length < 3) return 0;
    int16_t mean = tinyml_mean_x100(magnitude, length);
    int16_t std = tinyml_std_x100(magnitude, length);
    // 閾値 = mean + max(std * 1.5, 0.2G(=20 x100))
    int16_t std_term = (int32_t)std * 3 / 2;  // std * 1.5
    int16_t offset = std_term > 20 ? std_term : 20;
    int16_t high_thr = mean + offset;
    const int8_t REFRACTORY = 3;  // 150ms @ 20Hz
    int16_t count = 0;
    int8_t last_peak = -REFRACTORY;
    for (uint8_t i = 1; i < length - 1; i++) {
        if (magnitude[i] > magnitude[i-1] &&
            magnitude[i] > magnitude[i+1] &&
            magnitude[i] > high_thr) {
            if ((int8_t)i - last_peak >= REFRACTORY) {
                count++;
                last_peak = (int8_t)i;
            }
        }
    }
    return count * 100;  // x100スケールで返却
}

// 特徴量抽出メイン関数
void tinyml_extract_features(int16_t* buffer_x, int16_t* buffer_y, int16_t* buffer_z,
                             uint8_t length, int16_t* features_x100) {
    // X軸統計量
    features_x100[0] = tinyml_mean_x100(buffer_x, length);
    features_x100[1] = tinyml_std_x100(buffer_x, length);
    
    // Y軸統計量
    features_x100[2] = tinyml_mean_x100(buffer_y, length);
    features_x100[3] = tinyml_std_x100(buffer_y, length);
    
    // Z軸統計量
    features_x100[4] = tinyml_mean_x100(buffer_z, length);
    features_x100[5] = tinyml_std_x100(buffer_z, length);
    
    // 合成加速度の計算（ローカル配列として宣言）
    int16_t magnitude[TINYML_WINDOW_SIZE];
    for (uint8_t i = 0; i < length; i++) {
        int32_t mag_sq = (int32_t)buffer_x[i] * buffer_x[i] + 
                         (int32_t)buffer_y[i] * buffer_y[i] + 
                         (int32_t)buffer_z[i] * buffer_z[i];
        magnitude[i] = (int16_t)sqrt((float)mag_sq);
    }
    
    // 合成加速度の統計量
    features_x100[6] = tinyml_mean_x100(magnitude, length);
    features_x100[7] = tinyml_std_x100(magnitude, length);
    
    // ゼロ交差率
    features_x100[8] = tinyml_zero_crossing_x100(buffer_x, length);
    features_x100[9] = tinyml_zero_crossing_x100(buffer_y, length);
    
    // ピーク数
    features_x100[10] = tinyml_count_peaks_x100(buffer_x, length);
    features_x100[11] = tinyml_count_peaks_x100(buffer_y, length);
    
    // 範囲とエネルギー
    features_x100[12] = tinyml_range(magnitude, length);
    features_x100[13] = tinyml_energy_x100(magnitude, length);
    
    // 中央値とIQR（注意: magnitudeがソートされる）
    // 一時配列を作成してソート
    int16_t magnitude_copy[TINYML_WINDOW_SIZE];
    for (uint8_t i = 0; i < length; i++) {
        magnitude_copy[i] = magnitude[i];
    }
    
    features_x100[14] = tinyml_median_x100(magnitude_copy, length);
    features_x100[15] = tinyml_iqr_x100(magnitude_copy, length);

    // 16: 強い衝撃ピーク数（クリック=1, ダブルクリック=2 等の識別用）
    features_x100[16] = tinyml_count_strong_peaks(magnitude, length);
}
`;
    }

    /**
     * 決定木をテーブル構造に変換
     */
    _convertTreeToTable(tree) {
        const nodes = [];
        
        function traverse(node, nodeIndex) {
            if (node.isLeaf) {
                nodes[nodeIndex] = {
                    isLeaf: true,
                    predictedClass: node.predictedClass
                };
                return;
            }
            
            const leftIndex = nodes.length;
            nodes.push(null);
            const rightIndex = nodes.length;
            nodes.push(null);
            
            nodes[nodeIndex] = {
                isLeaf: false,
                featureIndex: node.featureIndex,
                threshold: node.threshold,
                leftChild: leftIndex,
                rightChild: rightIndex
            };
            
            traverse(node.left, leftIndex);
            traverse(node.right, rightIndex);
        }
        
        nodes.push(null);
        traverse(tree, 0);
        
        return { nodes };
    }

    /**
     * 最適化版：決定木コード生成（PROGMEM使用）
     */
    generateOptimizedDecisionTreeCode() {
        if (!this.model || !this.model.tree) {
            throw new Error('モデルが訓練されていません');
        }
        
        const numClasses = this.labelMap.size;
        const treeTable = this._convertTreeToTable(this.model.tree);
        
        let code = `
// TinyML 学習済みモデル（決定木・最適化版）
// 生成日時: ${new Date().toISOString()}
// クラス数: ${numClasses}
// ノード数: ${treeTable.nodes.length}

#define TINYML_NUM_CLASSES ${numClasses}
#define TINYML_NUM_NODES ${treeTable.nodes.length}

// 決定木ノードテーブル
// 構造: [is_leaf, feature_index, threshold_x100, left_child, right_child, predicted_class]
const int16_t tinyml_tree_table[][6] PROGMEM = {
`;
    
        for (let i = 0; i < treeTable.nodes.length; i++) {
            const node = treeTable.nodes[i];
            if (node.isLeaf) {
                code += `    {1, 0, 0, 0, 0, ${node.predictedClass}}`;
            } else {
                const thresholdX100 = Math.round(node.threshold * 100);
                code += `    {0, ${node.featureIndex}, ${thresholdX100}, ${node.leftChild}, ${node.rightChild}, 0}`;
            }
            if (i < treeTable.nodes.length - 1) code += ',';
            code += '\n';
        }
        
        code += `};

// 予測関数（テーブル駆動型）
int tinyml_predict(int16_t* features_x100) {
    int16_t node_idx = 0;
    
    while (1) {
        int16_t is_leaf = pgm_read_word(&tinyml_tree_table[node_idx][0]);
        
        if (is_leaf) {
            return pgm_read_word(&tinyml_tree_table[node_idx][5]);
        }
        
        int16_t feature_idx = pgm_read_word(&tinyml_tree_table[node_idx][1]);
        int16_t threshold_x100 = pgm_read_word(&tinyml_tree_table[node_idx][2]);
        
        if (features_x100[feature_idx] <= threshold_x100) {
            node_idx = pgm_read_word(&tinyml_tree_table[node_idx][3]);
        } else {
            node_idx = pgm_read_word(&tinyml_tree_table[node_idx][4]);
        }
    }
}
`;
    
        return code;
    }

    /**
     * MLP モデルの推論C++コードを生成する。
     * 出力 API は決定木と同じ: int tinyml_predict(int16_t* features_x100)
     * 重みは正規化と x100スケーリングを焼き込んだ float を PROGMEM に格納。
     */
    generateMLPInferenceCode() {
        if (!this.model || typeof this.model.getBakedWeights !== 'function') {
            throw new Error('MLPモデルが訓練されていません');
        }
        const mlp = this.model;
        const baked = mlp.getBakedWeights();
        const numClasses = this.labelMap.size;
        const HIDDEN = mlp.hiddenSize;
        const INPUT = mlp.inputSize;
        const paramCount = INPUT * HIDDEN + HIDDEN + HIDDEN * numClasses + numClasses;

        // C float リテラルへの変換。NaN/Infinity 対策。
        const f = (v) => {
            if (!Number.isFinite(v)) return '0.0f';
            return v.toExponential(6) + 'f';
        };

        let code = `
// TinyML 学習済みモデル(MLP, float forward pass)
// 生成日時: ${new Date().toISOString()}
// アーキテクチャ: ${INPUT} → ${HIDDEN}(ReLU) → ${numClasses}
// パラメータ総数: ${paramCount} (Flash使用量 ~${paramCount * 4}B)
// ※ 正規化(z-score)と x100 スケーリングを重みに焼き込み済み。
//    features_x100 をそのまま入力に渡せば正しい予測が出る。

#define TINYML_NUM_CLASSES ${numClasses}
#define TINYML_HIDDEN_SIZE ${HIDDEN}

const PROGMEM float TINYML_W1[${HIDDEN}][${INPUT}] = {
`;
        for (let i = 0; i < HIDDEN; i++) {
            code += '    {' + baked.W1[i].map(f).join(', ') + '}';
            if (i < HIDDEN - 1) code += ',';
            code += '\n';
        }
        code += `};
const PROGMEM float TINYML_B1[${HIDDEN}] = { ${baked.b1.map(f).join(', ')} };

const PROGMEM float TINYML_W2[${numClasses}][${HIDDEN}] = {
`;
        for (let c = 0; c < numClasses; c++) {
            code += '    {' + baked.W2[c].map(f).join(', ') + '}';
            if (c < numClasses - 1) code += ',';
            code += '\n';
        }
        code += `};
const PROGMEM float TINYML_B2[${numClasses}] = { ${baked.b2.map(f).join(', ')} };

// MLP 推論: features_x100[TINYML_FEATURE_SIZE] を入力にクラスIDを返す
int tinyml_predict(int16_t* features_x100) {
    float h[TINYML_HIDDEN_SIZE];
    // 隠れ層 + ReLU
    for (uint8_t i = 0; i < TINYML_HIDDEN_SIZE; i++) {
        float s = pgm_read_float(&TINYML_B1[i]);
        for (uint8_t j = 0; j < TINYML_FEATURE_SIZE; j++) {
            float w = pgm_read_float(&TINYML_W1[i][j]);
            s += w * (float)features_x100[j];
        }
        h[i] = s > 0.0f ? s : 0.0f;
    }
    // 出力層 (softmax は不要、argmax だけで決まる)
    int best = 0;
    float best_logit = -1e30f;
    for (uint8_t c = 0; c < TINYML_NUM_CLASSES; c++) {
        float s = pgm_read_float(&TINYML_B2[c]);
        for (uint8_t i = 0; i < TINYML_HIDDEN_SIZE; i++) {
            float w = pgm_read_float(&TINYML_W2[c][i]);
            s += w * h[i];
        }
        if (s > best_logit) { best_logit = s; best = c; }
    }
    return best;
}
`;
        return code;
    }

    /**
     * 最適化版：完全な推論コード生成
     */
    generateOptimizedInferenceCode() {
        if (!this.model) {
            throw new Error('モデルが訓練されていません');
        }
        
        return `
// センサーバッファとグローバル定義（最初に配置）
#define TINYML_WINDOW_SIZE 30
#define TINYML_SAMPLE_INTERVAL_MS 50  // 20Hz sampling
#define TINYML_FEATURE_SIZE 17  // 強い衝撃ピーク数 (index 16) を追加
// オーバーラップ推論: 15サンプル(=0.75秒)毎に推論を走らせる。
// 学習側もstepSize=15で訓練しているので統計分布が一致。
// 最悪レイテンシ: 1.5秒 → 0.75秒に半減。
#define TINYML_STEP_SIZE 15

// デバッグモード（trueにするとシリアルに特徴量を出力）
// ※ Arduino Pro Miniではメモリ不足になる場合があります
// ※ デバッグ時のみtrueに変更してください
#define TINYML_DEBUG_MODE false

// 時系列順バッファ(常に index 0=最古, index N-1=最新)。スライド方式で更新。
// メモリ追加コストなしでオーバーラップ推論を実現する。
int16_t tinyml_buffer_x[TINYML_WINDOW_SIZE];
int16_t tinyml_buffer_y[TINYML_WINDOW_SIZE];
int16_t tinyml_buffer_z[TINYML_WINDOW_SIZE];
uint8_t tinyml_fill_count = 0;             // 0..WINDOW_SIZE 現在埋まっているサンプル数
uint8_t tinyml_samples_since_inference = 0;
int16_t tinyml_features_x100[TINYML_FEATURE_SIZE];
int tinyml_predicted_class = 0;
unsigned long tinyml_last_sample_time = 0;
bool tinyml_buffer_filled = false;

// デバッグ用：特徴量出力（メモリ節約版）
#if TINYML_DEBUG_MODE
void tinyml_debug_features() {
    Serial.println(F("=== Features(x100) ==="));
    for (int i = 0; i < TINYML_FEATURE_SIZE; i++) {
        Serial.print(i);
        Serial.print(F(":"));
        Serial.println(tinyml_features_x100[i]);
    }
    Serial.print(F("Class:"));
    Serial.println(tinyml_predicted_class);
}
#endif

${this.generateOptimizedFeatureExtractionCode()}

${typeof this.model.getBakedWeights === 'function'
    ? this.generateMLPInferenceCode()
    : this.generateOptimizedDecisionTreeCode()}

// バッファ初期化関数
void tinyml_init() {
    for (uint8_t i = 0; i < TINYML_WINDOW_SIZE; i++) {
        tinyml_buffer_x[i] = 0;
        tinyml_buffer_y[i] = 0;
        tinyml_buffer_z[i] = 0;
    }
    tinyml_fill_count = 0;
    tinyml_samples_since_inference = 0;
    tinyml_buffer_filled = false;
    tinyml_predicted_class = 0;
}

// 一度だけ取得（取得後は次の推論まで-1を返す）
// サーボ等のブロッキング処理と組み合わせる場合に使用
bool tinyml_class_consumed = false;

// センサーデータを追加して推論
// スライド方式: バッファは常に時系列順 [oldest...newest]。
// 新サンプルが来たら左シフト+末尾追加。TINYML_STEP_SIZE 毎に推論。
// オーバーラップ推論により最悪レイテンシを 1.5秒 → 0.75秒 に短縮。
// 追加メモリ消費ゼロ(リングバッファ展開用一時バッファ不要)。
void tinyml_update(float accel_x, float accel_y, float accel_z) {
    unsigned long current_time = millis();

    if (current_time - tinyml_last_sample_time < TINYML_SAMPLE_INTERVAL_MS) {
        return;
    }
    tinyml_last_sample_time = current_time;

    const int16_t new_x = (int16_t)(accel_x * 100);
    const int16_t new_y = (int16_t)(accel_y * 100);
    const int16_t new_z = (int16_t)(accel_z * 100);

    if (tinyml_fill_count < TINYML_WINDOW_SIZE) {
        // 充填フェーズ: 末尾に追加するだけ
        tinyml_buffer_x[tinyml_fill_count] = new_x;
        tinyml_buffer_y[tinyml_fill_count] = new_y;
        tinyml_buffer_z[tinyml_fill_count] = new_z;
        tinyml_fill_count++;
        if (tinyml_fill_count >= TINYML_WINDOW_SIZE) {
            tinyml_buffer_filled = true;
        }
    } else {
        // 定常フェーズ: 全体を左シフトして末尾に新サンプル
        // 30×3×2byte = 180byte コピー/サンプル。50ms間隔なので余裕
        for (uint8_t i = 0; i < TINYML_WINDOW_SIZE - 1; i++) {
            tinyml_buffer_x[i] = tinyml_buffer_x[i + 1];
            tinyml_buffer_y[i] = tinyml_buffer_y[i + 1];
            tinyml_buffer_z[i] = tinyml_buffer_z[i + 1];
        }
        tinyml_buffer_x[TINYML_WINDOW_SIZE - 1] = new_x;
        tinyml_buffer_y[TINYML_WINDOW_SIZE - 1] = new_y;
        tinyml_buffer_z[TINYML_WINDOW_SIZE - 1] = new_z;
    }

    tinyml_samples_since_inference++;

    // バッファが満たされた状態で TINYML_STEP_SIZE サンプル積むごとに推論
    if (tinyml_buffer_filled && tinyml_samples_since_inference >= TINYML_STEP_SIZE) {
        tinyml_samples_since_inference = 0;
        // バッファは既に時系列順なのでそのまま渡せる
        tinyml_extract_features(tinyml_buffer_x, tinyml_buffer_y, tinyml_buffer_z,
                                TINYML_WINDOW_SIZE, tinyml_features_x100);
        tinyml_predicted_class = tinyml_predict(tinyml_features_x100);
        tinyml_class_consumed = false;

        #if TINYML_DEBUG_MODE
        tinyml_debug_features();
        #endif
    }
}

// 通常の取得（何度呼んでも同じ値を返す）
int tinyml_get_class() {
    if (!tinyml_buffer_filled) {
        return -1;  // まだ準備中
    }
    return tinyml_predicted_class;
}

int tinyml_get_class_once() {
    if (!tinyml_buffer_filled || tinyml_class_consumed) {
        return -1;
    }
    tinyml_class_consumed = true;
    return tinyml_predicted_class;
}

// 推論結果をリセット（次の推論まで-1を返すようになる）
void tinyml_reset_class() {
    tinyml_class_consumed = true;
}

bool tinyml_is_ready() {
    return tinyml_buffer_filled && !tinyml_class_consumed;
}
`;
    }
    // 既存のgenerateInferenceCode()は残しておく（互換性のため）
    generateInferenceCode() {
        // 最適化版を使用
        return this.generateOptimizedInferenceCode();
    }
    
    // 対応するメソッド追加（実際の処理はArduino側）

    updateInference() {
        // このブロックはSb2CppConverterでC変換される
        // ブラウザ上では何もしない
    }

    classifyOnArduino() {
        return 'Arduino側で実行';
    }

    isLabelOnArduino(args) {
        return false; // Arduino側で実行
    }

    /**
     * デバッグモードの切り替え
     */
    setDebugMode(args) {
        this.debugMode = (args.MODE === 'on');
        console.log(`[TinyML] デバッグモード: ${this.debugMode ? 'オン' : 'オフ'}`);
        if (this.debugMode) {
            console.log('[TinyML] ブラウザのコンソール（F12）で特徴量を確認できます');
        }
    }

    // TinyMLExtension に追加
    async debugSensorData(duration = 5000) {
        const data = [];
        const startTime = Date.now();
        
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (this.dataBuffer.length > 0) {
                    data.push({...this.dataBuffer[this.dataBuffer.length - 1]});
                }
                
                if (Date.now() - startTime >= duration) {
                    clearInterval(interval);
                    
                    // 統計情報を計算
                    const stats = this._calculateStats(data);
                    console.log('[TinyML Debug] センサーデータ統計:', stats);
                    
                    resolve(stats);
                }
            }, 50);
        });
    }

    _calculateStats(data) {
        if (data.length === 0) return null;
        
        const x = data.map(d => d.x);
        const y = data.map(d => d.y);
        const z = data.map(d => d.z);
        
        return {
            count: data.length,
            samplingRate: (data.length / 5).toFixed(1) + ' Hz',
            x: { min: Math.min(...x), max: Math.max(...x), mean: this._mean(x) },
            y: { min: Math.min(...y), max: Math.max(...y), mean: this._mean(y) },
            z: { min: Math.min(...z), max: Math.max(...z), mean: this._mean(z) }
        };
    }
    /**
     * グラフウィンドウを開く
     */
    openChart() {
        this.chartWindow.open();
    }

    /**
     * グラフウィンドウを閉じる
     */
    closeChart() {
        this.chartWindow.close();
    }

    /**
     * グラフウィンドウが開いているか確認
     */
    isChartOpen() {
        return this.chartWindow.isOpen();
    }
}

/**
 * 軽量決定木分類器
 * Arduino Pro miniで動作可能なシンプルな実装
 */
class SimpleDecisionTree {
    constructor(maxDepth = 5, minSamples = 5) {
        this.maxDepth = maxDepth;
        this.minSamples = minSamples;
        this.tree = null;
    }

    /**
     * 決定木の訓練
     */
    train(features, labels) {
        console.log('[DecisionTree] 訓練開始...');
        this.tree = this._buildTree(features, labels, 0);
        console.log('[DecisionTree] 訓練完了');
        return this;
    }

    /**
     * 再帰的に木を構築
     */
    _buildTree(features, labels, depth) {
        const numSamples = features.length;
        const numClasses = Math.max(...labels) + 1;
        
        // 停止条件
        if (depth >= this.maxDepth || numSamples < this.minSamples) {
            return this._createLeafNode(labels, numClasses);
        }
        
        // 全て同じラベル
        if (new Set(labels).size === 1) {
            return this._createLeafNode(labels, numClasses);
        }
        
        // 最適な分割を探す
        const split = this._findBestSplit(features, labels, numClasses);
        
        if (!split) {
            return this._createLeafNode(labels, numClasses);
        }
        
        // データを分割
        const leftIndices = [];
        const rightIndices = [];
        
        for (let i = 0; i < numSamples; i++) {
            if (features[i][split.featureIndex] <= split.threshold) {
                leftIndices.push(i);
            } else {
                rightIndices.push(i);
            }
        }
        
        // 分割が意味ない場合
        if (leftIndices.length === 0 || rightIndices.length === 0) {
            return this._createLeafNode(labels, numClasses);
        }
        
        // 再帰的に子ノードを構築
        const leftFeatures = leftIndices.map(i => features[i]);
        const leftLabels = leftIndices.map(i => labels[i]);
        const rightFeatures = rightIndices.map(i => features[i]);
        const rightLabels = rightIndices.map(i => labels[i]);
        
        return {
            isLeaf: false,
            featureIndex: split.featureIndex,
            threshold: split.threshold,
            left: this._buildTree(leftFeatures, leftLabels, depth + 1),
            right: this._buildTree(rightFeatures, rightLabels, depth + 1)
        };
    }

    /**
     * 葉ノード作成
     */
    _createLeafNode(labels, numClasses) {
        // 多数決でクラス決定
        const counts = new Array(numClasses).fill(0);
        for (const label of labels) {
            counts[label]++;
        }
        const predictedClass = counts.indexOf(Math.max(...counts));
        
        return {
            isLeaf: true,
            predictedClass: predictedClass,
            distribution: counts
        };
    }

    /**
     * 最適な分割点を探す
     */
    _findBestSplit(features, labels, numClasses) {
        const numFeatures = features[0].length;
        const numSamples = features.length;
        
        let bestGini = Infinity;
        let bestSplit = null;
        
        // 各特徴量について
        for (let featureIndex = 0; featureIndex < numFeatures; featureIndex++) {
            // 特徴量の値を取得してソート
            const values = features.map(f => f[featureIndex]);
            const uniqueValues = [...new Set(values)].sort((a, b) => a - b);
            
            // 各閾値について評価
            for (let i = 0; i < uniqueValues.length - 1; i++) {
                const threshold = (uniqueValues[i] + uniqueValues[i + 1]) / 2;
                
                // 分割
                const leftLabels = [];
                const rightLabels = [];
                
                for (let j = 0; j < numSamples; j++) {
                    if (features[j][featureIndex] <= threshold) {
                        leftLabels.push(labels[j]);
                    } else {
                        rightLabels.push(labels[j]);
                    }
                }
                
                if (leftLabels.length === 0 || rightLabels.length === 0) continue;
                
                // Gini不純度計算
                const gini = this._calculateGini(leftLabels, rightLabels, numClasses);
                
                if (gini < bestGini) {
                    bestGini = gini;
                    bestSplit = { featureIndex, threshold };
                }
            }
        }
        
        return bestSplit;
    }

    /**
     * Gini不純度計算
     */
    _calculateGini(leftLabels, rightLabels, numClasses) {
        const total = leftLabels.length + rightLabels.length;
        
        const giniLeft = this._giniImpurity(leftLabels, numClasses);
        const giniRight = this._giniImpurity(rightLabels, numClasses);
        
        return (leftLabels.length / total) * giniLeft + 
               (rightLabels.length / total) * giniRight;
    }

    /**
     * 単一グループのGini不純度
     */
    _giniImpurity(labels, numClasses) {
        if (labels.length === 0) return 0;
        
        const counts = new Array(numClasses).fill(0);
        for (const label of labels) {
            counts[label]++;
        }
        
        let gini = 1.0;
        for (const count of counts) {
            const prob = count / labels.length;
            gini -= prob * prob;
        }
        
        return gini;
    }

    /**
     * 予測
     */
    predict(features) {
        if (!this.tree) {
            throw new Error('モデルが未訓練です');
        }
        
        let node = this.tree;
        
        while (!node.isLeaf) {
            if (features[node.featureIndex] <= node.threshold) {
                node = node.left;
            } else {
                node = node.right;
            }
        }
        
        return node.predictedClass;
    }

    /**
     * 正解率計算
     */
    score(features, labels) {
        let correct = 0;
        for (let i = 0; i < features.length; i++) {
            if (this.predict(features[i]) === labels[i]) {
                correct++;
            }
        }
        return correct / features.length;
    }
}

/**
 * 純JS実装の小型MLP (Dense → ReLU → Dense → Softmax)
 *
 * 設計判断:
 * - TF.js を入れないことで scratch-vm のバンドル肥大化を回避
 * - mini-batch SGD with momentum + L2 + Dropout + Early stopping
 * - 入力は z-score 正規化(学習時に統計量を取り、predict時にも適用)
 * - getBakedWeights() で「正規化を重みに焼き込んだ float重み」を返す
 *   → ファーム側は features_x100 をそのまま入力すれば forward pass が走る
 * - SimpleDecisionTree と同じ {train, predict, score} API
 */
class SimpleMLP {
    constructor(inputSize, hiddenSize, numClasses, opts = {}) {
        this.inputSize = inputSize;
        this.hiddenSize = hiddenSize;
        this.numClasses = numClasses;

        this.l2 = opts.l2 != null ? opts.l2 : 0.001;
        this.dropout = opts.dropout != null ? opts.dropout : 0.2;
        this.lr = opts.lr != null ? opts.lr : 0.01;
        this.momentum = opts.momentum != null ? opts.momentum : 0.9;
        this.maxEpochs = opts.maxEpochs || 200;
        this.batchSize = opts.batchSize || 16;
        this.patience = opts.patience || 25;

        // He初期化 (ReLU向け): 標準偏差 sqrt(2/fan_in)
        this.W1 = this._initMatrix(hiddenSize, inputSize, Math.sqrt(2 / inputSize));
        this.b1 = new Array(hiddenSize).fill(0);
        this.W2 = this._initMatrix(numClasses, hiddenSize, Math.sqrt(2 / hiddenSize));
        this.b2 = new Array(numClasses).fill(0);

        // z-score 正規化用の統計量(train で計算)
        this.featureMean = new Array(inputSize).fill(0);
        this.featureStd = new Array(inputSize).fill(1);

        this.trainHistory = [];
    }

    _gauss() {
        // Box-Muller
        const u1 = Math.random() || 1e-9;
        const u2 = Math.random();
        return Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
    }

    _initMatrix(rows, cols, stddev) {
        const m = [];
        for (let r = 0; r < rows; r++) {
            const row = new Array(cols);
            for (let c = 0; c < cols; c++) row[c] = stddev * this._gauss();
            m.push(row);
        }
        return m;
    }

    _computeNormalization(features) {
        const n = features.length;
        const d = this.inputSize;
        for (let j = 0; j < d; j++) {
            let s = 0;
            for (let i = 0; i < n; i++) s += features[i][j];
            this.featureMean[j] = s / n;
        }
        for (let j = 0; j < d; j++) {
            let s = 0;
            for (let i = 0; i < n; i++) {
                const diff = features[i][j] - this.featureMean[j];
                s += diff * diff;
            }
            const std = Math.sqrt(s / n);
            // std=0 (一定値の特徴量) なら割り算で 0 除算しないよう保護
            this.featureStd[j] = std > 1e-6 ? std : 1.0;
        }
    }

    _normalize(x, dst) {
        for (let j = 0; j < this.inputSize; j++) {
            dst[j] = (x[j] - this.featureMean[j]) / this.featureStd[j];
        }
    }

    /**
     * 推論専用 forward (dropout なし)
     */
    _forward(x) {
        const H = this.hiddenSize;
        const C = this.numClasses;
        const D = this.inputSize;
        const h = new Array(H);
        for (let i = 0; i < H; i++) {
            let s = this.b1[i];
            const wi = this.W1[i];
            for (let j = 0; j < D; j++) s += wi[j] * x[j];
            h[i] = s > 0 ? s : 0;
        }
        const logits = new Array(C);
        for (let c = 0; c < C; c++) {
            let s = this.b2[c];
            const wc = this.W2[c];
            for (let i = 0; i < H; i++) s += wc[i] * h[i];
            logits[c] = s;
        }
        // Softmax (stable: subtract max)
        let maxL = logits[0];
        for (let c = 1; c < C; c++) if (logits[c] > maxL) maxL = logits[c];
        const probs = new Array(C);
        let sumE = 0;
        for (let c = 0; c < C; c++) { probs[c] = Math.exp(logits[c] - maxL); sumE += probs[c]; }
        for (let c = 0; c < C; c++) probs[c] /= sumE;
        return { h, logits, probs };
    }

    train(features, labels) {
        if (features.length === 0) throw new Error('No training data');
        if (features[0].length !== this.inputSize) {
            throw new Error(`Input size mismatch: expected ${this.inputSize}, got ${features[0].length}`);
        }

        this._computeNormalization(features);

        // 事前正規化(epoch ループ内で繰り返さない)
        const xs = features.map(f => {
            const out = new Array(this.inputSize);
            this._normalize(f, out);
            return out;
        });
        const ys = labels;

        // 内部 90/10 分割: 早期停止用 (外側の検証分割とは別)
        const perm = Array.from({ length: xs.length }, (_, i) => i);
        for (let i = perm.length - 1; i > 0; i--) {
            const k = Math.floor(Math.random() * (i + 1));
            [perm[i], perm[k]] = [perm[k], perm[i]];
        }
        const valSize = Math.max(1, Math.floor(xs.length * 0.1));
        const trainIdx = perm.slice(0, perm.length - valSize);
        const innerValIdx = perm.slice(perm.length - valSize);

        // モメンタムバッファ
        const vW1 = this.W1.map(r => new Array(r.length).fill(0));
        const vb1 = new Array(this.hiddenSize).fill(0);
        const vW2 = this.W2.map(r => new Array(r.length).fill(0));
        const vb2 = new Array(this.numClasses).fill(0);

        let bestValLoss = Infinity;
        let patienceCounter = 0;
        let bestWeights = null;

        for (let epoch = 0; epoch < this.maxEpochs; epoch++) {
            // 訓練 index をシャッフル
            for (let i = trainIdx.length - 1; i > 0; i--) {
                const k = Math.floor(Math.random() * (i + 1));
                [trainIdx[i], trainIdx[k]] = [trainIdx[k], trainIdx[i]];
            }

            let trainLossSum = 0;
            let trainBatches = 0;
            const H = this.hiddenSize;
            const C = this.numClasses;
            const D = this.inputSize;

            for (let bStart = 0; bStart < trainIdx.length; bStart += this.batchSize) {
                const batch = trainIdx.slice(bStart, bStart + this.batchSize);
                const bs = batch.length;

                // 勾配アキュムレータ
                const accW1 = this.W1.map(r => new Array(r.length).fill(0));
                const accb1 = new Array(H).fill(0);
                const accW2 = this.W2.map(r => new Array(r.length).fill(0));
                const accb2 = new Array(C).fill(0);

                let batchLoss = 0;

                for (const idx of batch) {
                    const x = xs[idx];
                    const target = ys[idx];

                    // === Forward (dropout 有効) ===
                    const hPre = new Array(H);
                    const hMask = new Array(H);
                    for (let i = 0; i < H; i++) {
                        let s = this.b1[i];
                        const wi = this.W1[i];
                        for (let j = 0; j < D; j++) s += wi[j] * x[j];
                        hPre[i] = s > 0 ? s : 0;
                        // Dropout (inverted): 訓練時にスケールアップして推論時はそのまま
                        if (this.dropout > 0 && Math.random() < this.dropout) {
                            hMask[i] = 0;
                        } else {
                            hMask[i] = this.dropout > 0 ? 1 / (1 - this.dropout) : 1;
                        }
                    }
                    const h = new Array(H);
                    for (let i = 0; i < H; i++) h[i] = hPre[i] * hMask[i];

                    const logits = new Array(C);
                    for (let c = 0; c < C; c++) {
                        let s = this.b2[c];
                        const wc = this.W2[c];
                        for (let i = 0; i < H; i++) s += wc[i] * h[i];
                        logits[c] = s;
                    }

                    // Softmax
                    let maxL = logits[0];
                    for (let c = 1; c < C; c++) if (logits[c] > maxL) maxL = logits[c];
                    let sumE = 0;
                    const probs = new Array(C);
                    for (let c = 0; c < C; c++) { probs[c] = Math.exp(logits[c] - maxL); sumE += probs[c]; }
                    for (let c = 0; c < C; c++) probs[c] /= sumE;

                    batchLoss += -Math.log(Math.max(1e-9, probs[target]));

                    // === Backward ===
                    // 出力層: dL/dlogits = probs - onehot(target)
                    const dLogits = probs.slice();
                    dLogits[target] -= 1;

                    // 隠れ層への勾配 (W2を通じて)
                    const dH = new Array(H).fill(0);
                    for (let c = 0; c < C; c++) {
                        const dLc = dLogits[c];
                        accb2[c] += dLc;
                        const accRow = accW2[c];
                        const wRow = this.W2[c];
                        for (let i = 0; i < H; i++) {
                            accRow[i] += dLc * h[i];
                            dH[i] += wRow[i] * dLc;
                        }
                    }
                    // Dropoutマスクの勾配 + ReLU の勾配
                    for (let i = 0; i < H; i++) {
                        dH[i] *= hMask[i];
                        if (hPre[i] <= 0) dH[i] = 0;
                    }
                    // W1, b1 の勾配
                    for (let i = 0; i < H; i++) {
                        const dHi = dH[i];
                        accb1[i] += dHi;
                        const accRow = accW1[i];
                        for (let j = 0; j < D; j++) accRow[j] += dHi * x[j];
                    }
                }

                trainLossSum += batchLoss / bs;
                trainBatches++;

                // === SGD + Momentum + L2 ===
                const invBs = 1 / bs;
                for (let i = 0; i < H; i++) {
                    const vw1i = vW1[i];
                    const w1i = this.W1[i];
                    const aw1i = accW1[i];
                    for (let j = 0; j < D; j++) {
                        const g = aw1i[j] * invBs + this.l2 * w1i[j];
                        vw1i[j] = this.momentum * vw1i[j] - this.lr * g;
                        w1i[j] += vw1i[j];
                    }
                    const gb = accb1[i] * invBs;
                    vb1[i] = this.momentum * vb1[i] - this.lr * gb;
                    this.b1[i] += vb1[i];
                }
                for (let c = 0; c < C; c++) {
                    const vw2c = vW2[c];
                    const w2c = this.W2[c];
                    const aw2c = accW2[c];
                    for (let i = 0; i < H; i++) {
                        const g = aw2c[i] * invBs + this.l2 * w2c[i];
                        vw2c[i] = this.momentum * vw2c[i] - this.lr * g;
                        w2c[i] += vw2c[i];
                    }
                    const gb = accb2[c] * invBs;
                    vb2[c] = this.momentum * vb2[c] - this.lr * gb;
                    this.b2[c] += vb2[c];
                }
            }

            // 内部検証ロス (dropout なし) で早期停止判定
            let valLossSum = 0;
            for (const idx of innerValIdx) {
                const fwd = this._forward(xs[idx]);
                valLossSum += -Math.log(Math.max(1e-9, fwd.probs[ys[idx]]));
            }
            const innerValLoss = valLossSum / innerValIdx.length;
            const avgTrainLoss = trainBatches > 0 ? trainLossSum / trainBatches : 0;
            this.trainHistory.push({ epoch, trainLoss: avgTrainLoss, valLoss: innerValLoss });

            if (innerValLoss < bestValLoss - 1e-4) {
                bestValLoss = innerValLoss;
                patienceCounter = 0;
                bestWeights = {
                    W1: this.W1.map(r => r.slice()),
                    b1: this.b1.slice(),
                    W2: this.W2.map(r => r.slice()),
                    b2: this.b2.slice()
                };
            } else {
                patienceCounter++;
                if (patienceCounter >= this.patience) {
                    console.log(`[MLP] Early stop at epoch ${epoch + 1}, bestValLoss=${bestValLoss.toFixed(4)}`);
                    break;
                }
            }

            if (epoch % 10 === 0 || epoch === this.maxEpochs - 1) {
                console.log(`[MLP] epoch ${epoch}, trainLoss=${avgTrainLoss.toFixed(4)}, innerValLoss=${innerValLoss.toFixed(4)}`);
            }
        }

        if (bestWeights) {
            this.W1 = bestWeights.W1;
            this.b1 = bestWeights.b1;
            this.W2 = bestWeights.W2;
            this.b2 = bestWeights.b2;
        }
    }

    predict(features) {
        const x = new Array(this.inputSize);
        this._normalize(features, x);
        const fwd = this._forward(x);
        let best = 0;
        let bestL = fwd.logits[0];
        for (let c = 1; c < this.numClasses; c++) {
            if (fwd.logits[c] > bestL) { bestL = fwd.logits[c]; best = c; }
        }
        return best;
    }

    /**
     * クラスごとの softmax 確率を返す (信頼度表示用)
     */
    predictProba(features) {
        const x = new Array(this.inputSize);
        this._normalize(features, x);
        return this._forward(x).probs;
    }

    score(features, labels) {
        let correct = 0;
        for (let i = 0; i < features.length; i++) {
            if (this.predict(features[i]) === labels[i]) correct++;
        }
        return correct / features.length;
    }

    /**
     * ファーム側C++コード生成用に、正規化と x100 スケーリングを「重みに焼き込んだ」
     * 重みを返す。ファーム側はこれを使って features_x100 をそのまま forward すればよい。
     *
     * 内部: forward 数式は h = ReLU(W1 @ ((x - mean) / std) + b1)
     *       これを変形して: h = ReLU((W1 / std) @ x + (b1 - W1 @ (mean/std)))
     *       さらに firmware features_x100 = features * 100 を吸収:
     *       W1_baked[i][j] = W1[i][j] / std[j] / 100
     *       b1_baked[i]    = b1[i] - Σj W1[i][j] * mean[j] / std[j]
     */
    getBakedWeights() {
        const H = this.hiddenSize;
        const D = this.inputSize;
        const W1_baked = [];
        for (let i = 0; i < H; i++) {
            const row = new Array(D);
            for (let j = 0; j < D; j++) {
                row[j] = this.W1[i][j] / this.featureStd[j] / 100;
            }
            W1_baked.push(row);
        }
        const b1_baked = new Array(H);
        for (let i = 0; i < H; i++) {
            let bias = this.b1[i];
            for (let j = 0; j < D; j++) {
                bias -= this.W1[i][j] * this.featureMean[j] / this.featureStd[j];
            }
            b1_baked[i] = bias;
        }
        return {
            W1: W1_baked,
            b1: b1_baked,
            W2: this.W2.map(r => r.slice()),
            b2: this.b2.slice()
        };
    }
}

module.exports = TinyMLExtension;